// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAiInterviewConfig = z.object({
    $schema: z.url().readonly().optional(),
    agent_id: z.string(),
});

export const zAddress = z.object({
    city: z.string().optional(),
    country: z.string().optional(),
    line_1: z.string().optional(),
    line_2: z.string().optional(),
    postal_code: z.string().optional(),
    region: z.string().optional(),
});

export const zApplicationFitGap = z.object({
    feedback: z.string().optional(),
    text: z.string(),
});

export const zApplicationFitResponse = z.object({
    $schema: z.url().readonly().optional(),
    gaps: z.array(zApplicationFitGap).optional(),
    highlights: z.array(z.string()).optional(),
    highlights_feedback: z.string().optional(),
    last_updated: z.iso.datetime({ offset: true }).optional(),
    status: z.enum(['pending', 'generating', 'ready', 'failed']),
});

export const zBackgroundCheckCountryPricing = z.object({
    country_code: z.string(),
    eta_days_max: z.int(),
    eta_days_min: z.int(),
    price: z.string(),
});

export const zBankAccountActiveContract = z.object({
    company_logo: z.string().optional(),
    company_name: z.string(),
    id: z.int(),
    role: z.string(),
});

export const zBankAccount = z.object({
    $schema: z.url().readonly().optional(),
    account_number: z.string().optional(),
    account_type: z
        .enum(['personal_checking', 'personal_savings', 'business_checking', 'business_savings'])
        .optional(),
    active_contracts: z.array(zBankAccountActiveContract).optional(),
    address: zAddress,
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    contracting_entity_id: z.int().optional(),
    contracting_entity_name: z.string().optional(),
    country: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    editable: z.boolean(),
    errors: z.array(z.string()).optional(),
    iban: z.string().optional(),
    id: z.int(),
    legal_name: z.string(),
    memo: z.string().optional(),
    phone_number: z.string().optional(),
    primary: z.boolean(),
    routing_number: z.string().optional(),
    status: z.enum(['active', 'pending', 'rejected', 'inactive']),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zBasicCustomer = z.object({
    id: z.int(),
    logo: z.string().optional(),
    name: z.string(),
});

export const zBasicUser = z.object({
    first_name: z.string(),
    id: z.int(),
    last_name: z.string(),
    picture: z.string().optional(),
});

export const zBackgroundCheckOrder = z.object({
    completed_at: z.iso.datetime({ offset: true }).optional(),
    contractor: zBasicUser.optional(),
    created_at: z.iso.datetime({ offset: true }),
    customer_id: z.int(),
    customer_invoice_id: z.int().optional(),
    customer_invoice_month: z.int().optional(),
    customer_invoice_year: z.int().optional(),
    customer_logo: z.string().optional(),
    customer_name: z.string(),
    id: z.int(),
    ordered_at: z.iso.datetime({ offset: true }).optional(),
    price: z.string(),
    status: z.enum([
        'draft',
        'order_failed',
        'invitation_sent',
        'invitation_expired',
        'in_progress',
        'suspended',
        'paused',
        'dispute',
        'action_required',
        'completed',
        'rejected',
        'canceled',
    ]),
    work_country: z.string(),
});

export const zBackgroundCheckOrdersResponse = z.object({
    $schema: z.url().readonly().optional(),
    background_checks: z.array(zBackgroundCheckOrder),
    current_page: z.int(),
    total: z.int(),
    total_pages: z.int(),
});

export const zBasicCandidate = z.object({
    id: z.int(),
    user: zBasicUser,
});

export const zBonus = z.object({
    $schema: z.url().readonly().optional(),
    amount: z.string(),
    comment: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    effective_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    status: z.enum(['pending', 'approved', 'rejected']),
});

export const zBulkImIneligible = z.object({
    candidate_id: z.int(),
    reason: z.string(),
});

export const zBulkImPreflightResponse = z.object({
    $schema: z.url().readonly().optional(),
    ineligible: z.array(zBulkImIneligible),
    scheduled: z.int(),
});

export const zBulkImSendResponse = z.object({
    $schema: z.url().readonly().optional(),
    batch_id: z.string(),
    ineligible: z.array(zBulkImIneligible),
    scheduled: z.int(),
});

export const zBulkImVariable = z.object({
    platform_field: z.string().optional(),
    static_value: z.string().optional(),
});

export const zBulkImSendRequest = z.object({
    $schema: z.url().readonly().optional(),
    candidate_ids: z.array(z.int()).min(1),
    template_id: z.int(),
    variables: z.record(z.string(), zBulkImVariable),
});

export const zCandidateCertificationEntry = z.object({
    action: z.enum(['created', 'updated', 'deleted']),
    author: zBasicUser.optional(),
    certification_id: z.string(),
    changed_at: z.iso.datetime({ offset: true }),
    changed_fields: z.array(z.string()).optional(),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    source: z.enum(['manual', 'linkedin']),
});

export const zCandidateExpectedSalaryEntry = z.object({
    amount: z.string(),
    author: zBasicUser.optional(),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    timestamp: z.iso.datetime({ offset: true }),
});

export const zCandidateExperimentsEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    experiments: z.array(z.string()),
    id: z.int(),
});

export const zCandidateOpenToOpportunitiesEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    open_to_opportunities: z.boolean(),
});

export const zCandidateProfileCompleteEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    profile_complete: z.boolean(),
});

export const zCandidateProfileUpdateSection = z.object({
    comments: z.string().max(5000).optional(),
    section: z.enum(['about', 'work_history']),
});

export const zCandidateProfileUpdateRequest = z.object({
    $schema: z.url().readonly().optional(),
    event_uri: z.string().optional(),
    id: z.int(),
    method: z.enum(['written_details', 'booked_call']),
    sections: z.array(zCandidateProfileUpdateSection),
});

export const zCandidateSeniorityEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    previous_seniority: z
        .enum(['IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'IC6', 'M5', 'M6', 'lead', 'manager', 'director'])
        .optional(),
    reason: z.string().optional(),
    seniority: z.enum([
        'IC1',
        'IC2',
        'IC3',
        'IC4',
        'IC5',
        'IC6',
        'M5',
        'M6',
        'lead',
        'manager',
        'director',
    ]),
});

export const zCandidateSourceEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    referrer_id: z.int().optional(),
    source: z.enum([
        'onboard',
        'referral',
        'gitsight',
        'sourced',
        'careers_site',
        'claria',
        'linkedin',
        'typeform',
        'calendly',
        'contractor',
        'hunting_torre',
        'hunting_consider',
        'hunting_linkedin',
        'hunting_progai',
        'paid',
        'organic',
        'external_recruiter',
        'dripify',
        'other',
    ]),
});

export const zCandidateStatusEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    legacy_job: z.string().optional(),
    reason: z.string().optional(),
    status: z.enum([
        'sourced',
        'first_contact',
        'second_contact',
        'disqualified_lead',
        'disqualified',
        'declined',
        'applicant',
        'network_accepted',
        'hired_customer',
        'anonymized',
    ]),
});

export const zCandidateVerification = z.object({
    candidate_id: z.int(),
    country_matches: z.boolean().optional(),
    country_not_matched_valid_reason: z.boolean().optional(),
    document_url: z.string().optional(),
    id: z.int(),
    id_matches: z.boolean().optional(),
    inquiry_id: z.string().optional(),
    reason: z.string().optional(),
    requested_by: zBasicUser.optional(),
    reviewed_by: zBasicUser.optional(),
    status: z.enum([
        'pending',
        'started',
        'completed',
        'failed',
        'expired',
        'approved',
        'declined',
    ]),
});

export const zCandidateWorkExperienceEntry = z.object({
    action: z.enum(['created', 'updated', 'deleted']),
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    changed_fields: z.array(z.string()).optional(),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    source: z.enum([
        'manual',
        'linkedin',
        'ai_profile_builder',
        'contract_termination',
        'ai_experience_formatter',
    ]),
    work_experience_id: z.string(),
});

export const zCertification = z.object({
    evidence: z.string().optional(),
    hidden: z.boolean().optional(),
    id: z.string(),
    month: z.int().optional(),
    name: z.string().min(1),
    organization: z.string().min(1),
    year: z.int().optional(),
});

export const zCertificationInput = z.object({
    evidence: z.string().optional(),
    hidden: z.boolean().optional(),
    id: z.uuid().optional(),
    month: z.int().optional(),
    name: z.string().min(1),
    organization: z.string().min(1),
    year: z.int().optional(),
});

export const zCheckBankAccountNameRequest = z.object({
    $schema: z.url().readonly().optional(),
    account_type: z.enum([
        'personal_checking',
        'personal_savings',
        'business_checking',
        'business_savings',
    ]),
    contracting_entity_id: z.int(),
    name: z.string().min(1),
});

export const zCheckBankAccountNameResult = z.object({
    $schema: z.url().readonly().optional(),
    expected_name: z.string(),
    result: z.enum(['ok', 'needs_review', 'rejected']),
});

export const zCompanyOpening = z.object({
    id: z.int(),
    permalink: z.string(),
    posted_at: z.iso.datetime({ offset: true }).nullable(),
    salary_currency: z.string().optional(),
    salary_end: z.string().nullable(),
    salary_start: z.string().nullable(),
    tags: z.array(z.string()),
    title: z.string(),
});

export const zCompanyTeamMember = z.object({
    linkedin_url: z.string(),
    name: z.string(),
    picture: z.string(),
});

export const zCompensationChange = z.object({
    $schema: z.url().readonly().optional(),
    comment: z.string(),
    created_at: z.iso.datetime({ offset: true }).optional(),
    effective_at: z.iso.datetime({ offset: true }),
    id: z.int().optional(),
    kind: z.enum(['raise', 'original']),
    new: z.string(),
    old: z.string().optional(),
    status: z.enum(['pending', 'approved', 'rejected']).optional(),
});

export const zContractGroup = z.object({
    id: z.int(),
    name: z.string(),
});

export const zContractHealthInsurance = z.object({
    cost: z.string().optional(),
    provider: z.enum(['none', 'remotely', 'customer']),
    status: z
        .enum([
            'draft',
            'accepted',
            'rejected',
            'updated_info',
            'expired',
            'pending',
            'active',
            'canceled',
        ])
        .optional(),
    type: z.enum(['none', 'stipend', 'safetywing']),
});

export const zContractingEntityContractInfo = z.object({
    contract_id: z.int(),
    current: z.boolean(),
    customer_company_name: z.string(),
    customer_id: z.int(),
    customer_logo: z.string().nullable(),
    pending: z.boolean(),
    role: z.string(),
});

export const zContractingEntitySelectionStatusResponse = z.object({
    $schema: z.url().readonly().optional(),
    completed: z.boolean(),
    requested: z.boolean(),
});

export const zContractingEntityTaxForm = z.object({
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    signed: z.boolean(),
    url: z.string().optional(),
});

export const zContractingEntity = z.object({
    $schema: z.url().readonly().optional(),
    address: zAddress,
    business_structure: z
        .enum([
            'ltd',
            'simplified_joint_stock_company',
            'llc',
            'corporation',
            'other',
            'joint_stock_company',
        ])
        .optional(),
    business_structure_other: z.string().optional(),
    contracts: z.array(zContractingEntityContractInfo),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    locked: z.boolean(),
    name: z.string(),
    phone: z.string().optional(),
    status: z.enum(['available', 'retired', 'pending']),
    taxForm: zContractingEntityTaxForm.optional(),
    tax_id: z.string().optional(),
    title: z.string().optional(),
    type: z.enum(['individual', 'business']),
    updated_at: z.iso.datetime({ offset: true }),
});

export const zContractorCheckin = z.object({
    $schema: z.url().readonly().optional(),
    calendly_url: z.string(),
    campaign: z.enum(['d30', 'd60', 'd90', 'd180', 'd270', 'quarterly']),
    completed_at: z.iso.datetime({ offset: true }).optional(),
    contractor_email: z.string(),
    contractor_full_name: z.string(),
    customer_company_name: z.string(),
    days: z.int(),
    id: z.int(),
    meeting_scheduled_at: z.iso.datetime({ offset: true }).optional(),
    status: z.enum(['pending', 'scheduled', 'completed', 'expired']),
    videoask_url: z.string(),
});

export const zContractorDocument = z.object({
    amendment_type: z.enum(['salary', 'entity', 'country']).optional(),
    created_at: z.iso.datetime({ offset: true }),
    customer: z.string().optional(),
    id: z.int(),
    name: z.string(),
    signed_at: z.iso.datetime({ offset: true }).optional(),
    tax_form_type: z.enum(['w8ben', 'w8ben-e', 'w9']).optional(),
    type: z.enum([
        'CA',
        'EA',
        'tax_form',
        'termination',
        'code_of_conduct',
        'amendment',
        'other',
        'offer_letter',
        'background_check',
        'equipment',
        'expense',
    ]),
    url: z.string(),
});

export const zContractorHealthEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    comment: z.string().optional(),
    created_at: z.iso.datetime({ offset: true }),
    health: z.enum(['strong', 'monitor', 'at_risk', 'healthy', 'critical', 'exit']),
    id: z.int(),
    reason: z.enum(['customer_feedback', 'conflicting_feedback', 'feedback_outdated', 'other']),
});

export const zContractorHealthHistory = z.object({
    change_type: z
        .enum(['manual', 'checkin_score', 'checkin_no_data', 'contract_terminated', 'backfill'])
        .optional(),
    changed_at: z.iso.datetime({ offset: true }),
    comment: z.string().optional(),
    health: z.enum(['strong', 'monitor', 'at_risk', 'healthy', 'critical', 'exit']).optional(),
    reason: z.enum(['customer_feedback', 'conflicting_feedback', 'feedback_outdated', 'other']),
    score: z.int().optional(),
    user_first_name: z.string(),
    user_last_name: z.string(),
    user_picture: z.string(),
});

export const zContractorHealthResponse = z.object({
    $schema: z.url().readonly().optional(),
    current_health: z
        .enum(['strong', 'monitor', 'at_risk', 'healthy', 'critical', 'exit'])
        .optional(),
    current_reason: z
        .enum(['customer_feedback', 'conflicting_feedback', 'feedback_outdated', 'other'])
        .optional(),
    history: z.array(zContractorHealthHistory),
    updated_at: z.iso.datetime({ offset: true }).optional(),
});

export const zCreateBankAccountRequest = z.object({
    $schema: z.url().readonly().optional(),
    account_number: z.string().optional(),
    account_type: z.enum([
        'personal_checking',
        'personal_savings',
        'business_checking',
        'business_savings',
    ]),
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    contracting_entity_id: z.int(),
    country: z.string().length(2),
    iban: z.string().optional(),
    legal_name: z.string().min(1),
    memo: z.string().optional(),
    primary: z.boolean().optional(),
    routing_number: z.string().optional(),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zCreateBonusRequest = z.object({
    $schema: z.url().readonly().optional(),
    amount: z.string(),
    comment: z.string().max(2000).optional(),
    effective_at: z.iso.datetime({ offset: true }),
});

export const zCreateCustomerGroupRequest = z.object({
    $schema: z.url().readonly().optional(),
    approval_id: z.int().nullish(),
    approval_type: z.enum(['company', 'custom']),
    name: z.string().min(1),
    notes: z.string().optional(),
});

export const zCreateCustomerUserRequest = z.object({
    $schema: z.url().readonly().optional(),
    email: z.string(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    roles: z
        .array(
            z.enum(['customer', 'customer_interviewer', 'customer_manager', 'customer_recruiter']),
        )
        .min(1),
    scheduling_url: z.string().nullish(),
});

export const zCreateEquipmentRequest = z.object({
    $schema: z.url().readonly().optional(),
    brand: z.string().min(1),
    contract_id: z.int().optional(),
    cost: z.string(),
    customer_id: z.int(),
    description: z.string().optional(),
    invoice_id: z.int().optional(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    location: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .optional(),
    model: z.string().min(1),
    offer_letter_id: z.int().optional(),
    part_number: z.string().optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
});

export const zCreateRaiseRequest = z.object({
    $schema: z.url().readonly().optional(),
    comment: z.string().max(2000).optional(),
    effective_at: z.iso.datetime({ offset: true }),
    new: z.string(),
});

export const zCurrentPaymentAccount = z.object({
    last_digits: z.string(),
});

export const zBankAccountChange = z.object({
    $schema: z.url().readonly().optional(),
    account_number: z.string().optional(),
    account_type: z
        .enum(['personal_checking', 'personal_savings', 'business_checking', 'business_savings'])
        .optional(),
    active_contracts: z.array(zBankAccountActiveContract).optional(),
    address: zAddress,
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    contracting_entity_id: z.int().optional(),
    contracting_entity_name: z.string().optional(),
    country: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    current_payment: zCurrentPaymentAccount.optional(),
    editable: z.boolean(),
    errors: z.array(z.string()).optional(),
    iban: z.string().optional(),
    id: z.int(),
    legal_name: z.string(),
    memo: z.string().optional(),
    phone_number: z.string().optional(),
    primary: z.boolean(),
    routing_number: z.string().optional(),
    status: z.enum(['active', 'pending', 'rejected', 'inactive']),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zCustomerBasicProfile = z.object({
    $schema: z.url().readonly().optional(),
    header: z.string().nullable(),
    logo: z.string().nullable(),
    name: z.string(),
    permalink: z.string(),
});

export const zCustomerBillingContact = z.object({
    email: z.string(),
    first_name: z.string(),
    id: z.int(),
    last_name: z.string(),
    picture: z.string().optional(),
    status: z.enum([
        'active',
        'inactive',
        'anonymization_pending',
        'anonymization_failed',
        'anonymization_complete',
    ]),
});

export const zCustomerBillingDetails = z.object({
    auto_payment: z.boolean(),
    deposit_months: z.int().nullable(),
    ein: z.string(),
    legal_name: z.string(),
    mercury_id: z.string(),
    payment_reminder_disabled: z.boolean(),
});

export const zCustomerBillingData = z.object({
    $schema: z.url().readonly().optional(),
    address: zAddress.optional(),
    contacts: z.array(zCustomerBillingContact),
    details: zCustomerBillingDetails,
});

export const zCustomerContractor = z.object({
    email: z.string(),
    first_name: z.string(),
    id: z.int(),
    last_name: z.string(),
    picture: z.string(),
});

export const zCustomerGroup = z.object({
    $schema: z.url().readonly().optional(),
    approval_id: z.int().nullable(),
    approval_type: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    customer_id: z.int(),
    id: z.int(),
    name: z.string(),
    notes: z.string(),
    total_contractors: z.int(),
});

export const zCustomerGroupApprover = z.object({
    company_level: z.boolean(),
    first_name: z.string(),
    id: z.int(),
    last_name: z.string(),
    picture: z.string(),
});

export const zCustomerInvoice = z.object({
    company_name: z.string(),
    contractors: z.string(),
    customer_id: z.int(),
    deposits: z.string(),
    equipment: z.string(),
    expenses: z.string(),
    id: z.int(),
    month: z.int(),
    other: z.string(),
    remotely: z.string(),
    severances: z.string(),
    status: z.enum([
        'draft',
        'reviewed',
        'issued',
        'sent',
        'payment_scheduled',
        'review_payment',
        'paid',
        'written_off',
    ]),
    total: z.string(),
    year: z.int(),
});

export const zCustomerInvoicesResponse = z.object({
    $schema: z.url().readonly().optional(),
    current_page: z.int(),
    invoices: z.array(zCustomerInvoice),
    total: z.int(),
    total_pages: z.int(),
});

export const zCustomerStageEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    stage: z.enum(['agency', 'early', 'growth', 'mature', 'pe_backed', 'post_ipo']),
});

export const zCustomerUser = z.object({
    $schema: z.url().readonly().optional(),
    created_at: z.iso.datetime({ offset: true }),
    email: z.string(),
    first_name: z.string(),
    hubspot_id: z.string().optional(),
    id: z.int(),
    inactive: z.boolean(),
    job_title: z.string(),
    last_activity_at: z.iso.datetime({ offset: true }).nullable(),
    last_name: z.string(),
    picture: z.string(),
    roles: z.array(z.string()),
    scheduling_url: z.string().optional(),
    type_of_role: z.string(),
});

export const zDocument = z.object({
    id: z.int(),
    name: z.string(),
    url: z.string(),
});

export const zEmergencyContact = z.object({
    name: z.string(),
    phone: z.string(),
    relationship: z.string(),
});

export const zContactInfoRequest = z.object({
    $schema: z.url().readonly().optional(),
    email: z.string(),
    emergency_contact: zEmergencyContact,
    telephone: z.array(z.string()),
});

export const zContactInfoResponse = z.object({
    $schema: z.url().readonly().optional(),
    country: z.string(),
    email: z.string(),
    emergency_contact: zEmergencyContact,
    telephone: z.array(z.string()),
});

export const zEmploymentDetails = z.object({
    approval_manager: zBasicUser.optional(),
    fee_type: z.enum(['fixed', 'pay_as_you_go']),
    group_id: z.int().optional(),
    group_name: z.string().optional(),
    manager: zBasicUser.optional(),
    rate: z.string().optional(),
    role: z.string(),
    salary: z.string(),
    seniority: z
        .enum(['IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'IC6', 'M5', 'M6', 'lead', 'manager', 'director'])
        .optional(),
    start_date: z.iso.datetime({ offset: true }),
    stock_options: z.string().optional(),
});

export const zEmploymentInsurance = z.object({
    cost: z.string().optional(),
    dependants: z.int().optional(),
    offered: z.boolean(),
    plan: z.enum(['STANDARD', 'PREMIUM', 'MATERNITY']).optional(),
    renewal_date: z.iso.datetime({ offset: true }).optional(),
    status: z
        .enum([
            'draft',
            'accepted',
            'rejected',
            'updated_info',
            'expired',
            'pending',
            'active',
            'canceled',
        ])
        .optional(),
    stipend: z.string().optional(),
    type: z.enum(['none', 'stipend', 'safetywing']),
});

export const zEquipment = z.object({
    $schema: z.url().readonly().optional(),
    accounting_status: z.enum(['pending', 'invoiced', 'paid']),
    brand: z.string(),
    confirmed_at: z.iso.datetime({ offset: true }).optional(),
    contract_id: z.int().optional(),
    cost: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    customer_id: z.int(),
    customer_invoice_id: z.int().optional(),
    deleted_at: z.iso.datetime({ offset: true }).optional(),
    delivered_at: z.iso.datetime({ offset: true }).optional(),
    description: z.string().optional(),
    expected_delivery: z.iso.datetime({ offset: true }).optional(),
    finished_delivery: z.iso.datetime({ offset: true }).optional(),
    id: z.int(),
    invoice: zDocument.optional(),
    invoice_id: z.int().optional(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    location: z.string().optional(),
    model: z.string(),
    offer_letter_id: z.int().optional(),
    order_number: z.string().optional(),
    ordered_at: z.iso.datetime({ offset: true }).optional(),
    part_number: z.string().optional(),
    picture: zDocument.optional(),
    picture_id: z.int().optional(),
    purchased_at: z.iso.datetime({ offset: true }).optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
    updated_at: z.iso.datetime({ offset: true }),
});

export const zEmploymentEquipment = z.object({
    items: z.array(zEquipment),
    provided: z.boolean(),
});

export const zContractorEmploymentInfo = z.object({
    $schema: z.url().readonly().optional(),
    employment: zEmploymentDetails,
    equipment: zEmploymentEquipment,
    insurance: zEmploymentInsurance,
});

export const zErrorCode = z.enum([
    'malformed_request',
    'invalid_phone',
    'invalid_country',
    'invalid_region',
    'business_structure_required',
    'business_structure_other_required',
    'tax_id_required',
    'title_required',
    'individual_contracting_entity_already_exists',
    'locked_entity',
    'no_active_contract',
    'contracting_entity_already_assigned',
    'no_pending_selection',
    'invalid_cbu',
    'invalid_tax_id',
    'invalid_routing_number',
    'invalid_account_number',
    'invalid_swift',
    'invalid_iban',
    'invalid_clabe',
    'invalid_transit_number',
    'invalid_bank_code',
    'invalid_memo',
    'address_line1_required',
    'invalid_address_country',
    'invalid_address_region',
    'address_city_required',
    'address_postal_code_required',
    'bank_account_name_rejected',
    'bank_account_cant_edit',
    'bank_account_incomplete_address',
    'bank_account_type_mismatch',
    'bank_account_not_active',
    'bank_account_entity_mismatch',
    'bank_account_does_not_exist',
    'invalid_fit_index',
    'user_exists',
    'group_exists',
    'user_not_found',
    'group_not_found',
    'invalid_timezone',
    'invalid_url',
    'invalid_linkedin_url',
    'invalid_employees_range',
    'invalid_market',
    'invalid_section',
    'invalid_tags',
    'has_responsibilities',
    'invalid_roles',
    'invalid_status',
    'invalid_domain',
    'domains_taken',
    'file_too_large',
    'invalid_contacts',
    'laptop_spec_required',
    'invalid_client_approver',
    'certification_invalid_year',
    'certification_invalid_month',
    'certification_year_required_for_month',
    'contract_invalid_management_fee',
    'contract_invalid_health_insurance_cost',
    'contract_invalid_start_date',
    'contract_invalid_termination_date',
    'contract_termination_cannot_add',
    'contract_termination_cannot_clear',
    'contract_manager_not_in_customer',
    'contract_approval_manager_not_in_customer',
    'contract_group_not_in_customer',
    'contract_none_provider_safetywing',
    'invoice_regenerates_empty',
    'invoice_cant_be_deleted',
    'invalid_first_name',
    'invalid_last_name',
    'invalid_birthday',
    'invalid_email',
    'invalid_scheduling_url',
    'invalid_github_url',
    'residency_locked',
    'address_country_locked',
    'cant_change_target_salary',
    'emergency_contact_name_required',
    'emergency_contact_relationship_required',
    'invalid_id',
    'not_pending',
    'only_one_supporting_material',
    'invalid_recording_url',
    'invalid_document_type',
    'feedback_required',
    'campaign_not_eligible',
    'invalid_event_uri',
    'meeting_not_active',
    'contract_not_active',
    'effective_date_required',
    'raise_on_pay_as_you_go',
    'raise_amount_not_positive',
    'raise_no_change',
    'raise_decrease_not_allowed',
    'bonus_amount_not_positive',
    'bonus_effective_date_in_past',
    'job_expansion_already_applied',
    'profile_update_duplicate_section',
    'profile_update_comments_required',
    'profile_update_comments_not_allowed',
    'profile_update_single_section_needed',
    'profile_update_event_uri_required',
    'profile_update_event_uri_not_allowed',
    'profile_update_event_already_reported',
    'verification_reason_required',
    'verification_valid_reason_required',
    'verification_not_reviewable',
]);

export const zApiError = z.object({
    detail: z.string().optional(),
    errors: z
        .array(
            z.object({
                code: zErrorCode.optional(),
                location: z.string().optional(),
                message: z.string().optional(),
                value: z.unknown().optional(),
            }),
        )
        .optional(),
    status: z.int().optional(),
    title: z.string().optional(),
    type: z.string().optional(),
});

export const zExpandJobRequest = z.object({
    $schema: z.url().readonly().optional(),
    expansions: z.array(z.enum(['seniority', 'current_salary'])).min(1),
});

export const zExpandJobResponse = z.object({
    $schema: z.url().readonly().optional(),
    matches: z.int(),
});

export const zFinishProfileBuilderRequest = z.object({
    $schema: z.url().readonly().optional(),
    permalink: z.string().min(1),
});

export const zFinishProfileBuilderResponse = z.object({
    $schema: z.url().readonly().optional(),
    valid: z.boolean(),
});

export const zHealthInsurancePlanAddon = z.object({
    description: z.string(),
    insurance_percentage: z.number(),
    max_covered_per_period: z.number(),
    type: z.enum([
        'DENTAL',
        'VISION',
        'SCREENING',
        'MATERNITY',
        'OUTPATIENT',
        'THERAPIES',
        'MENTAL_HEALTH',
    ]),
});

export const zHealthInsurancePlanPricing = z.object({
    amount: z.number(),
    from_age: z.int(),
    to_age: z.int(),
});

export const zHealthInsurancePlan = z.object({
    $schema: z.url().readonly().optional(),
    addons: z.array(zHealthInsurancePlanAddon),
    id: z.int(),
    name: z.string(),
    pricings: z.array(zHealthInsurancePlanPricing),
    type: z.enum(['STANDARD', 'PREMIUM', 'MATERNITY']),
    valid_from: z.iso.datetime({ offset: true }),
    valid_until: z.iso.datetime({ offset: true }),
});

export const zHolidays = z.object({
    days: z.int().nullable(),
    description: z.string().optional(),
    fixed: z.int().nullable(),
    per_country: z.boolean(),
});

export const zInitAiInterviewRequest = z.object({
    $schema: z.url().readonly().optional(),
    conversation_id: z.string().min(1),
});

export const zItem = z.object({
    feedback: z.string().min(1).max(500),
    index: z.int().gte(0).lte(10),
});

export const zJobContract = z.object({
    entity: z.string().optional(),
    fee_type: z.enum(['fixed', 'pay_as_you_go']),
    overlap: z.enum(['full', 'partial', 'none']).optional(),
    position: z.string(),
    rate: z.string().optional(),
    salary: z.string(),
    start_date: z.iso.datetime({ offset: true }),
    stocks: z.string().optional(),
    working_timezone: z.string().optional(),
});

export const zJobEquipment = z.object({
    brand: z.string(),
    id: z.int(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    model: z.string(),
    part_number: z.string().optional(),
    purchased_at: z.iso.datetime({ offset: true }).optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
});

export const zJobExpansionCount = z.object({
    count: z.int(),
    expansion: z.enum(['seniority', 'current_salary']),
});

export const zJobExpansionsPreviewResponse = z.object({
    $schema: z.url().readonly().optional(),
    combined: z.int(),
    expansions: z.array(zJobExpansionCount),
});

export const zJobInsurance = z.object({
    can_use_safety_wing: z.boolean(),
    cost: z.string().optional(),
    dependants: z.int().optional(),
    plan: z.enum(['STANDARD', 'PREMIUM', 'MATERNITY']).optional(),
    renewal_date: z.iso.datetime({ offset: true }).optional(),
    status: z
        .enum([
            'draft',
            'accepted',
            'rejected',
            'updated_info',
            'expired',
            'pending',
            'active',
            'canceled',
        ])
        .optional(),
    stipend: z.string().optional(),
    type: z.enum(['none', 'stipend', 'safetywing']),
});

export const zJobOpeningCompanyOwnerEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    company_owner_id: z.int(),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
});

export const zJobOpeningHealthEntry = z.object({
    author: zBasicUser.optional(),
    changed_at: z.iso.datetime({ offset: true }),
    comment: z.string().optional(),
    created_at: z.iso.datetime({ offset: true }),
    health: z.enum(['on_track', 'off_track', 'at_risk']),
    id: z.int(),
});

export const zJobPtoPolicy = z.object({
    description: z.string(),
    id: z.int(),
    name: z.string(),
    structure: z.enum(['fixed_number', 'unlimited', 'local_holidays', 'us_only']),
});

export const zJobDetails = z.object({
    $schema: z.url().readonly().optional(),
    company: zBasicCustomer,
    contract: zJobContract,
    equipment: z.array(zJobEquipment),
    group: z.string().optional(),
    insurance: zJobInsurance,
    manager: zBasicUser.optional(),
    pto: z.array(zJobPtoPolicy),
});

export const zLaptopSpecifications = z.object({
    allow_personal: z.boolean(),
    comments: z.string().optional(),
    extra_items: z.string().optional(),
    os: z.string(),
    ram: z.string(),
    screen_size: z.string(),
    spanish_keyboard: z.boolean(),
    ssd: z.string(),
});

export const zCustomerPoliciesBenefits = z.object({
    $schema: z.url().readonly().optional(),
    background_check: z.boolean(),
    customer_status: z.enum([
        'prospect',
        'not_working_not_hiring',
        'not_working_hiring',
        'working_hiring',
        'working_not_hiring',
        'recruiting_only_hiring',
        'recruiting_only_not_hiring',
        'churned',
        'closed_lost',
    ]),
    equipment: z.enum(['not_provided', 'provided']).optional(),
    health_insurance: z.enum(['provided_by_customer', 'provided_by_remotely', 'not_offered']),
    is_grandfathered_customer: z.boolean(),
    laptop_specifications: zLaptopSpecifications.optional(),
    offer_expiration_days: z.int(),
    on_call: z.enum(['always_required', 'never_required', 'role_specific']).optional(),
    other_benefits: z.string(),
    policies_configured: z.boolean(),
    recruiting_only: z.boolean(),
    special_clauses: z.string(),
    stock_options_type: z.enum(['negotiable', 'yes', 'not_offered']),
    timezone: z.string(),
    timezone_overlap: z.enum(['full', 'partial', 'none']),
});

export const zLaptopSpecificationsRequest = z.object({
    allow_personal: z.boolean().optional(),
    comments: z.string().optional(),
    extra_items: z.string().optional(),
    os: z.string().optional(),
    ram: z.string().optional(),
    screen_size: z.string().optional(),
    spanish_keyboard: z.boolean().optional(),
    ssd: z.string().optional(),
});

export const zLegalAddress = z.object({
    $schema: z.url().readonly().optional(),
    city: z.string().min(1),
    country: z
        .string()
        .length(2)
        .regex(/^[A-Z]{2}$/),
    line_1: z.string().min(1),
    line_2: z.string().optional(),
    postal_code: z.string().min(1),
    region: z.string().min(1),
});

export const zCreateContractingEntityRequest = z.object({
    $schema: z.url().readonly().optional(),
    address: zLegalAddress,
    business_structure: z
        .enum([
            'ltd',
            'simplified_joint_stock_company',
            'llc',
            'corporation',
            'other',
            'joint_stock_company',
        ])
        .optional(),
    business_structure_other: z.string().optional(),
    name: z.string().min(1),
    phone: z.string().optional(),
    tax_id: z.string().optional(),
    title: z.string().optional(),
    type: z.enum(['individual', 'business']),
});

export const zLocationResponse = z.object({
    $schema: z.url().readonly().optional(),
    address: zAddress,
    country_locked: z.boolean(),
});

export const zOpsApproval = z.object({
    $schema: z.url().readonly().optional(),
    created_at: z.iso.datetime({ offset: true }),
    entity_id: z.int(),
    id: z.int(),
    owner: zBasicUser.optional(),
    rejection_reason: z.string().optional(),
    reviewed_at: z.iso.datetime({ offset: true }).optional(),
    reviewed_by: zBasicUser.optional(),
    status: z.enum(['pending', 'approved', 'rejected']),
    summary: z.string(),
    type: z.enum(['bank_account_mismatch', 'country_change', 'id_verification_review']),
    user: zBasicUser,
    verification: zCandidateVerification.optional(),
});

export const zListOpsApprovalsResponse = z.object({
    $schema: z.url().readonly().optional(),
    approvals: z.array(zOpsApproval),
    current_page: z.int(),
    total: z.int(),
    total_pages: z.int(),
});

export const zOtherPtoPolicy = z.object({
    name: z.string(),
    number: z.int().optional(),
});

export const zPto = z.object({
    days: z.int().nullable(),
    description: z.string().optional(),
    per_country: z.boolean(),
});

export const zBenefits = z.object({
    equipment: z.enum(['not_provided', 'provided']).optional(),
    health_insurance: z
        .enum(['provided_by_customer', 'provided_by_remotely', 'not_offered'])
        .optional(),
    holidays: zHolidays.optional(),
    laptop_specifications: zLaptopSpecifications.optional(),
    other_benefits: z.string().optional(),
    other_pto: z.array(zOtherPtoPolicy).optional(),
    pto: zPto.optional(),
    stocks: z.enum(['negotiable', 'yes', 'not_offered']).optional(),
});

export const zCustomerProfile = z.object({
    $schema: z.url().readonly().optional(),
    benefits: zBenefits,
    country: z.string().optional(),
    description: z.string(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineering_architecture: z.string(),
    engineers: z.int().nullable(),
    funding: z.int().nullable(),
    header: z.string().nullable(),
    hq: z.string(),
    hubspot_id: z.string().optional(),
    id: z.int(),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string(),
    logo: z.string().nullable(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string(),
    permalink: z.string(),
    product_demo: z.string(),
    public: z.boolean().optional(),
    sectors: z.array(z.int()),
    selling_pitch: z.string(),
    slack_channel_id: z.string().optional(),
    stage: z.enum(['agency', 'early', 'growth', 'mature', 'pe_backed', 'post_ipo']).optional(),
    status: z
        .enum([
            'prospect',
            'not_working_not_hiring',
            'not_working_hiring',
            'working_hiring',
            'working_not_hiring',
            'recruiting_only_hiring',
            'recruiting_only_not_hiring',
            'churned',
            'closed_lost',
        ])
        .optional(),
    tags: z.record(z.string(), z.string()),
    tech_stack: z.array(z.int()),
    timezone: z.string(),
    url: z.string(),
});

export const zPayContractorInvoiceInputBody = z.object({
    $schema: z.url().readonly().optional(),
    api_key: z.string().min(1).regex(/\S/),
});

export const zPaymentAttemptEntry = z.object({
    author: zBasicUser.optional(),
    bank_account_id: z.int(),
    beneficiary_id: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    emitted_at: z.iso.datetime({ offset: true }),
    failed_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    nium_response: z.string().optional(),
    payment_id: z.string(),
    status: z.enum([
        'draft',
        'pending',
        'error',
        'emitted',
        'returned',
        'expired',
        'paid',
        'emitting',
    ]),
});

export const zPendingChangesResponse = z.object({
    $schema: z.url().readonly().optional(),
    can_request_legal_name_change: z.boolean(),
    legal_name_change_in_review: z.boolean(),
    pending_country_change: zAddress.optional(),
});

export const zPersonalInfo = z.object({
    $schema: z.url().readonly().optional(),
    birthday: z.string().optional(),
    civil_status: z.enum(['single', 'married', 'living_together', 'divorced', 'widow']).optional(),
    email: z.string(),
    first_name: z.string(),
    gender: z.enum(['male', 'female', 'other']).optional(),
    last_name: z.string(),
    legal_name: z.string(),
    legal_name_change_in_review: z.boolean(),
    national_id: z.string().optional(),
    nationality: z.string().optional(),
    residency: z.string().optional(),
    residency_locked: z.boolean(),
    telephone: z.array(z.string()),
    time_zone: z.string().optional(),
    us_visa: z.boolean(),
    valid_passport: z.boolean(),
});

export const zProfileBuilderPermalinkResponse = z.object({
    $schema: z.url().readonly().optional(),
    permalink: z.string(),
});

export const zProfileJob = z.object({
    company: z.string(),
    company_logo: z.string().optional(),
    role: z.string(),
    started_at: z.iso.datetime({ offset: true }),
    terminated_at: z.iso.datetime({ offset: true }).optional(),
});

export const zProfilePersonalInfo = z.object({
    $schema: z.url().readonly().optional(),
    address: zAddress.optional(),
    birthday: z.iso.datetime({ offset: true }).optional(),
    civil_status: z.enum(['single', 'married', 'living_together', 'divorced', 'widow']).optional(),
    email: z.string(),
    first_name: z.string(),
    gender: z.enum(['male', 'female', 'other']).optional(),
    last_name: z.string(),
    legal_name: z.string(),
    nationality: z.string().optional(),
    residency: z.string().optional(),
    telephone: z.array(z.string()),
    time_zone: z.string().optional(),
    us_visa: z.boolean(),
    valid_passport: z.boolean(),
});

export const zProfileResponse = z.object({
    $schema: z.url().readonly().optional(),
    applicant_roles: z.array(z.string()),
    certifications: z.array(zCertification),
    emergency_contact: zEmergencyContact,
    github_url: z.string().optional(),
    has_contracting_entities: z.boolean(),
    has_design_role: z.boolean(),
    job_title: z.string().optional(),
    linkedin_url: z.string().optional(),
    personal_info: zProfilePersonalInfo,
    picture: z.string().optional(),
    portfolio_password: z.string().optional(),
    portfolio_url: z.string().optional(),
    public_id: z.string().optional(),
    resume_url: z.string().optional(),
    role: z.string().optional(),
    scheduling_url: z.string().optional(),
    target_salary: z.number(),
    technical_evidence_url: z.string().optional(),
    working_history: z.array(zProfileJob),
});

export const zProfileUpdateBookingUrlResponse = z.object({
    $schema: z.url().readonly().optional(),
    calendly_url: z.string(),
});

export const zPublicCustomerProfile = z.object({
    $schema: z.url().readonly().optional(),
    benefits: zBenefits,
    country: z.string().optional(),
    description: z.string(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineering_architecture: z.string(),
    engineers: z.int().nullable(),
    funding: z.int().nullable(),
    header: z.string().nullable(),
    hq: z.string(),
    hubspot_id: z.string().optional(),
    id: z.int(),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string(),
    logo: z.string().nullable(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string(),
    openings: z.array(zCompanyOpening),
    permalink: z.string(),
    product_demo: z.string(),
    public: z.boolean().optional(),
    sectors: z.array(z.int()),
    selling_pitch: z.string(),
    slack_channel_id: z.string().optional(),
    stage: z.enum(['agency', 'early', 'growth', 'mature', 'pe_backed', 'post_ipo']).optional(),
    status: z
        .enum([
            'prospect',
            'not_working_not_hiring',
            'not_working_hiring',
            'working_hiring',
            'working_not_hiring',
            'recruiting_only_hiring',
            'recruiting_only_not_hiring',
            'churned',
            'closed_lost',
        ])
        .optional(),
    tags: z.record(z.string(), z.string()),
    team: z.array(zCompanyTeamMember),
    tech_stack: z.array(z.int()),
    timezone: z.string(),
    url: z.string(),
});

export const zRaise = z.object({
    comment: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    effective_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    new: z.string(),
    old: z.string(),
    status: z.enum(['pending', 'approved', 'rejected']),
});

export const zContract = z.object({
    $schema: z.url().readonly().optional(),
    approval_manager_id: z.int().optional(),
    custom_management_fee: z.string().optional(),
    customer: z.string(),
    customer_group_id: z.int().optional(),
    customer_id: z.int(),
    customer_sourced: z.boolean(),
    deposit_id: z.int().optional(),
    deposit_months: z.int().optional(),
    description: z.string(),
    fee_type: z.enum(['fixed', 'pay_as_you_go']),
    group: zContractGroup.optional(),
    health_insurance: zContractHealthInsurance,
    id: z.int(),
    job_opening_id: z.int().optional(),
    manager: zBasicUser.optional(),
    manager_id: z.int().optional(),
    raises: z.array(zRaise),
    rate: z.string().optional(),
    resigned: z.boolean(),
    role: z.string(),
    roles: z.array(z.string()),
    salary: z.string(),
    stack: z.array(z.string()),
    started_at: z.iso.datetime({ offset: true }),
    status: z.enum([
        'draft',
        'in_progress',
        'active',
        'terminated',
        'resigned',
        'solicited',
        'canceled',
    ]),
    terminated_at: z.iso.datetime({ offset: true }).optional(),
    termination_reason: z
        .enum([
            'acquisition',
            'performance',
            'shutdown',
            'management',
            'restructuring',
            'provisional',
            'recruited',
            'unmotivated',
            'cancelled',
            'personal',
            'solicited',
        ])
        .optional(),
    user_id: z.int(),
});

export const zReassignResponsibilitiesRequest = z.object({
    $schema: z.url().readonly().optional(),
    approval_manager: z.int().optional(),
    billing_contact: z.int().optional(),
    customer_approval_manager: z.int().optional(),
    customer_contact: z.int().optional(),
    hiring_manager: z.int().optional(),
    interviewer: z.int().optional(),
    manager: z.int().optional(),
    offer_letter_contact: z.int().optional(),
});

export const zRecordQuoteApprovalRequest = z.object({
    $schema: z.url().readonly().optional(),
    client_approver_id: z.int().gte(1),
    comment: z.string().optional(),
});

export const zRejectOpsApprovalRequest = z.object({
    $schema: z.url().readonly().optional(),
    reason: z.string().max(2000).optional(),
});

export const zRequestContractingEntitySelectionRequest = z.object({
    $schema: z.url().readonly().optional(),
    application_id: z.int().nullish(),
});

export const zRequestProfileUpdateRequest = z.object({
    $schema: z.url().readonly().optional(),
    event_uri: z.string().optional(),
    method: z.enum(['written_details', 'booked_call']),
    sections: z.array(zCandidateProfileUpdateSection).min(1),
});

export const zReviewApplicationFitRequest = z.object({
    $schema: z.url().readonly().optional(),
    gaps: z.array(zItem).min(1),
    highlights: z.string().optional(),
});

export const zReviewCandidateVerificationRequest = z.object({
    $schema: z.url().readonly().optional(),
    country_matches: z.boolean(),
    country_not_matched_valid_reason: z.boolean().optional(),
    id_matches: z.boolean(),
    reason: z.string().optional(),
});

export const zSalaryChangeRequestResponse = z.object({
    $schema: z.url().readonly().optional(),
    notified: z.boolean(),
});

export const zScheduleContractorMeetingRequest = z.object({
    $schema: z.url().readonly().optional(),
    event_uri: z.string().min(1),
});

export const zSchedulingUrlRequest = z.object({
    $schema: z.url().readonly().optional(),
    scheduling_url: z.string(),
});

export const zSchedulingUrlResponse = z.object({
    $schema: z.url().readonly().optional(),
    scheduling_url: z.string(),
});

export const zSearchContractorsRequest = z.object({
    $schema: z.url().readonly().optional(),
    input: z.string(),
});

export const zSeniorityRequest = z.object({
    $schema: z.url().readonly().optional(),
    reason: z.string().optional(),
    seniority: z.enum(['IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'IC6', 'M5', 'M6']),
});

export const zSeniorityResponse = z.object({
    $schema: z.url().readonly().optional(),
    seniority: z
        .enum(['IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'IC6', 'M5', 'M6', 'lead', 'manager', 'director'])
        .optional(),
    updated_at: z.iso.datetime({ offset: true }).optional(),
    updated_by: zBasicUser.optional(),
});

export const zSetStatusRequest = z.object({
    $schema: z.url().readonly().optional(),
    reset: z.boolean().optional(),
    status: z
        .enum([
            'prospect',
            'not_working_not_hiring',
            'not_working_hiring',
            'working_hiring',
            'working_not_hiring',
            'recruiting_only_hiring',
            'recruiting_only_not_hiring',
            'churned',
            'closed_lost',
        ])
        .optional(),
});

export const zSetUserStatusRequest = z.object({
    $schema: z.url().readonly().optional(),
    active: z.boolean(),
});

export const zSetVisibilityRequest = z.object({
    $schema: z.url().readonly().optional(),
    public: z.boolean(),
});

export const zShippingInfoRequest = z.object({
    $schema: z.url().readonly().optional(),
    address: zLegalAddress,
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    national_id: z.string().min(5),
    telephone: z.string(),
    update_personal_info: z.boolean().optional(),
});

export const zShippingInfoResponse = z.object({
    $schema: z.url().readonly().optional(),
    address: zAddress,
    confirmed: z.boolean(),
    country_locked: z.boolean(),
    customer: zCustomerBasicProfile.optional(),
    first_name: z.string(),
    last_name: z.string(),
    last_update: z.iso.datetime({ offset: true }).optional(),
    national_id: z.string().optional(),
    personal_address: zAddress,
    telephone: z.string().optional(),
});

export const zStartProfileBuilderRequest = z.object({
    $schema: z.url().readonly().optional(),
    conversation_id: z.string().min(1),
});

export const zUpdateBankAccountRequest = z.object({
    $schema: z.url().readonly().optional(),
    account_number: z.string().optional(),
    account_type: z.enum([
        'personal_checking',
        'personal_savings',
        'business_checking',
        'business_savings',
    ]),
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    country: z.string().length(2),
    iban: z.string().optional(),
    legal_name: z.string().min(1),
    memo: z.string().optional(),
    primary: z.boolean().optional(),
    routing_number: z.string().optional(),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zUpdateBillingAddressRequest = z.object({
    $schema: z.url().readonly().optional(),
    legal_address: zLegalAddress,
});

export const zUpdateBillingContactsRequest = z.object({
    $schema: z.url().readonly().optional(),
    contacts: z.array(z.int()),
});

export const zUpdateBillingDetailsRequest = z.object({
    $schema: z.url().readonly().optional(),
    auto_payment: z.boolean().optional(),
    deposit_months: z.int().gte(0).optional(),
    ein: z.string().optional(),
    legal_name: z.string().min(1),
    mercury_id: z.string().optional(),
    payment_reminder_disabled: z.boolean().optional(),
});

export const zUpdateCandidatePersonalInfoRequest = z.object({
    $schema: z.url().readonly().optional(),
    birthdate: z.string().optional(),
    email: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    phones: z.array(z.string()).optional(),
    scheduling_url: z.string().optional(),
    timezone: z.string().optional(),
});

export const zUpdateCertificationsRequest = z.object({
    $schema: z.url().readonly().optional(),
    certifications: z.array(zCertificationInput),
});

export const zUpdateContractRequest = z.object({
    $schema: z.url().readonly().optional(),
    approval_manager_id: z.int().gte(1),
    customer_group_id: z.int().optional(),
    customer_sourced: z.boolean().optional(),
    deposit_months: z.int().gte(0).optional(),
    description: z.string().optional(),
    health_insurance_cost: z.string().optional(),
    health_insurance_provider: z.enum(['none', 'remotely', 'customer']),
    management_fee: z.string().optional(),
    manager_id: z.int().gte(1),
    role: z.string().min(1),
    started_at: z.iso.datetime({ offset: true }),
    terminated_at: z.iso.datetime({ offset: true }).optional(),
});

export const zUpdateContractingEntityRequest = z.object({
    $schema: z.url().readonly().optional(),
    address: zLegalAddress,
    business_structure: z
        .enum([
            'ltd',
            'simplified_joint_stock_company',
            'llc',
            'corporation',
            'other',
            'joint_stock_company',
        ])
        .optional(),
    business_structure_other: z.string().optional(),
    name: z.string().min(1).optional(),
    phone: z.string().optional(),
    tax_id: z.string().optional(),
    title: z.string().optional(),
    type: z.enum(['individual', 'business']).optional(),
});

export const zUpdateContractorHealthRequest = z.object({
    $schema: z.url().readonly().optional(),
    comment: z.string().optional(),
    health: z.enum(['strong', 'monitor', 'at_risk', 'healthy', 'critical', 'exit']).optional(),
    reason: z.enum(['customer_feedback', 'conflicting_feedback', 'feedback_outdated', 'other']),
});

export const zUpdateContractorInvoiceAccountInputBody = z.object({
    $schema: z.url().readonly().optional(),
    account_id: z.int().optional(),
});

export const zUpdateContractorInvoiceStatusRequest = z.object({
    $schema: z.url().readonly().optional(),
    status: z.enum([
        'draft',
        'error',
        'approved',
        'issued',
        'payment_scheduled',
        'paid',
        'pending',
    ]),
});

export const zUpdateCustomerDetailsRequest = z.object({
    $schema: z.url().readonly().optional(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineers: z.int().gte(0).optional(),
    funding: z.int().gte(0).optional(),
    hq: z.string().min(1),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string().optional(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string().min(1),
    sectors: z.array(z.int()).optional(),
    tech_stack: z.array(z.int()).optional(),
    timezone: z.string(),
    url: z.string().optional(),
});

export const zUpdateCustomerInvoiceStatusRequest = z.object({
    $schema: z.url().readonly().optional(),
    status: z.enum([
        'draft',
        'reviewed',
        'issued',
        'sent',
        'payment_scheduled',
        'review_payment',
        'paid',
        'written_off',
    ]),
});

export const zUpdateCustomerPoliciesBenefitsRequest = z.object({
    $schema: z.url().readonly().optional(),
    background_check: z.boolean(),
    equipment: z.enum(['not_provided', 'provided']).optional(),
    health_insurance: z.enum(['provided_by_customer', 'provided_by_remotely', 'not_offered']),
    laptop_specifications: zLaptopSpecificationsRequest.optional(),
    offer_expiration_days: z.int().gte(0).lte(14).optional(),
    on_call: z.enum(['always_required', 'never_required', 'role_specific']).optional(),
    other_benefits: z.string().optional(),
    special_clauses: z.string().optional(),
    stock_options_type: z.enum(['negotiable', 'yes', 'not_offered']),
    timezone: z.string(),
    timezone_overlap: z.enum(['full', 'partial', 'none']),
});

export const zUpdateCustomerProfileRequest = z.object({
    $schema: z.url().readonly().optional(),
    description: z.string(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineering_architecture: z.string().optional(),
    engineers: z.int().gte(0).optional(),
    funding: z.int().gte(0).optional(),
    hq: z.string().min(1),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string().optional(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string().min(1),
    product_demo: z.string().optional(),
    sectors: z.array(z.int()).optional(),
    selling_pitch: z.string().optional(),
    tech_stack: z.array(z.int()).optional(),
    timezone: z.string(),
    url: z.string().optional(),
});

export const zUpdateCustomerSectionRequest = z.object({
    $schema: z.url().readonly().optional(),
    content: z.string().optional(),
    section: z.enum(['description', 'selling_pitch', 'engineering_architecture', 'product_demo']),
});

export const zUpdateCustomerTalentPreferencesInputBody = z.object({
    $schema: z.url().readonly().optional(),
    value: z.string().optional(),
});

export const zUpdateEmploymentInfoRequest = z.object({
    $schema: z.url().readonly().optional(),
    approval_manager_id: z.int(),
    group_id: z.int().optional(),
    manager_id: z.int(),
});

export const zUpdateEquipmentRequest = z.object({
    $schema: z.url().readonly().optional(),
    brand: z.string().min(1),
    contract_id: z.int().optional(),
    cost: z.string(),
    customer_id: z.int(),
    description: z.string().optional(),
    invoice_id: z.int().optional(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    location: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .optional(),
    model: z.string().min(1),
    offer_letter_id: z.int().optional(),
    part_number: z.string().optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
});

export const zUpdatePersonalInfoRequest = z.object({
    $schema: z.url().readonly().optional(),
    birthday: z.string().optional(),
    civil_status: z.enum(['single', 'married', 'living_together', 'divorced', 'widow']).optional(),
    first_name: z.string(),
    gender: z.enum(['male', 'female', 'other']).optional(),
    last_name: z.string(),
    national_id: z.string().optional(),
    nationality: z.string().optional(),
    residency: z.string().optional(),
    time_zone: z.string().optional(),
    us_visa: z.boolean().optional(),
    valid_passport: z.boolean().optional(),
});

export const zUpdateTargetSalaryInputBody = z.object({
    $schema: z.url().readonly().optional(),
    target_salary: z.number().gte(0),
});

export const zUploadPictureResponse = z.object({
    $schema: z.url().readonly().optional(),
    url: z.string(),
});

export const zUploadResponse = z.object({
    $schema: z.url().readonly().optional(),
    url: z.string(),
});

export const zUserResponsibilities = z.object({
    $schema: z.url().readonly().optional(),
    approval_manager: z.int().optional(),
    billing_contact: z.int().optional(),
    customer_approval_manager: z.int().optional(),
    customer_contact: z.int().optional(),
    hiring_manager: z.int().optional(),
    interviewer: z.int().optional(),
    manager: z.int().optional(),
    offer_letter_contact: z.int().optional(),
});

export const zWorkExperiencePeriod = z.object({
    from: z.iso.datetime({ offset: true }),
    to: z.iso.datetime({ offset: true }),
});

export const zWorkExperience = z.object({
    company: z.string(),
    company_url: z.string(),
    contract_id: z.int().optional(),
    customer_id: z.int().optional(),
    description: z.string(),
    id: z.string().optional(),
    industries: z.array(z.int()),
    is_current: z.boolean(),
    period: zWorkExperiencePeriod,
    position: z.string(),
    quit_reason: z.string(),
    stack: z.array(z.int()).optional(),
});

export const zProfileBuilderWorkHistoryResponse = z.object({
    $schema: z.url().readonly().optional(),
    agent_id: z.string(),
    work_experience: z.array(zWorkExperience),
});

export const zWorkInfoRequest = z.object({
    $schema: z.url().readonly().optional(),
    job_title: z.string().min(1),
    scheduling_url: z.string().optional(),
});

export const zWorkInfoResponse = z.object({
    $schema: z.url().readonly().optional(),
    job_title: z.string(),
    scheduling_url: z.string(),
});

export const zWorkProfileRequest = z.object({
    $schema: z.url().readonly().optional(),
    github_url: z.string(),
    linkedin_url: z.string(),
    portfolio_password: z.string(),
    portfolio_url: z.string(),
    resume_url: z.string(),
    scheduling_url: z.string(),
    target_salary: z.number().gte(0),
    technical_evidence_url: z.string(),
});

export const zWorkProfileResponse = z.object({
    $schema: z.url().readonly().optional(),
    github_url: z.string(),
    has_design_role: z.boolean(),
    linkedin_url: z.string(),
    portfolio_password: z.string().optional(),
    portfolio_url: z.string().optional(),
    resume_url: z.string(),
    scheduling_url: z.string(),
    target_salary: z.number(),
    technical_evidence_url: z.string(),
});

export const zAiInterviewConfigWritable = z.object({
    agent_id: z.string(),
});

export const zApplicationFitResponseWritable = z.object({
    gaps: z.array(zApplicationFitGap).optional(),
    highlights: z.array(z.string()).optional(),
    highlights_feedback: z.string().optional(),
    last_updated: z.iso.datetime({ offset: true }).optional(),
    status: z.enum(['pending', 'generating', 'ready', 'failed']),
});

export const zBackgroundCheckOrdersResponseWritable = z.object({
    background_checks: z.array(zBackgroundCheckOrder),
    current_page: z.int(),
    total: z.int(),
    total_pages: z.int(),
});

export const zBankAccountWritable = z.object({
    account_number: z.string().optional(),
    account_type: z
        .enum(['personal_checking', 'personal_savings', 'business_checking', 'business_savings'])
        .optional(),
    active_contracts: z.array(zBankAccountActiveContract).optional(),
    address: zAddress,
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    contracting_entity_id: z.int().optional(),
    contracting_entity_name: z.string().optional(),
    country: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    editable: z.boolean(),
    errors: z.array(z.string()).optional(),
    iban: z.string().optional(),
    id: z.int(),
    legal_name: z.string(),
    memo: z.string().optional(),
    phone_number: z.string().optional(),
    primary: z.boolean(),
    routing_number: z.string().optional(),
    status: z.enum(['active', 'pending', 'rejected', 'inactive']),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zBankAccountChangeWritable = z.object({
    account_number: z.string().optional(),
    account_type: z
        .enum(['personal_checking', 'personal_savings', 'business_checking', 'business_savings'])
        .optional(),
    active_contracts: z.array(zBankAccountActiveContract).optional(),
    address: zAddress,
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    contracting_entity_id: z.int().optional(),
    contracting_entity_name: z.string().optional(),
    country: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    current_payment: zCurrentPaymentAccount.optional(),
    editable: z.boolean(),
    errors: z.array(z.string()).optional(),
    iban: z.string().optional(),
    id: z.int(),
    legal_name: z.string(),
    memo: z.string().optional(),
    phone_number: z.string().optional(),
    primary: z.boolean(),
    routing_number: z.string().optional(),
    status: z.enum(['active', 'pending', 'rejected', 'inactive']),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zBonusWritable = z.object({
    amount: z.string(),
    comment: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    effective_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    status: z.enum(['pending', 'approved', 'rejected']),
});

export const zBulkImPreflightResponseWritable = z.object({
    ineligible: z.array(zBulkImIneligible),
    scheduled: z.int(),
});

export const zBulkImSendRequestWritable = z.object({
    candidate_ids: z.array(z.int()).min(1),
    template_id: z.int(),
    variables: z.record(z.string(), zBulkImVariable),
});

export const zBulkImSendResponseWritable = z.object({
    batch_id: z.string(),
    ineligible: z.array(zBulkImIneligible),
    scheduled: z.int(),
});

export const zCandidateProfileUpdateRequestWritable = z.object({
    event_uri: z.string().optional(),
    id: z.int(),
    method: z.enum(['written_details', 'booked_call']),
    sections: z.array(zCandidateProfileUpdateSection),
});

export const zCheckBankAccountNameRequestWritable = z.object({
    account_type: z.enum([
        'personal_checking',
        'personal_savings',
        'business_checking',
        'business_savings',
    ]),
    contracting_entity_id: z.int(),
    name: z.string().min(1),
});

export const zCheckBankAccountNameResultWritable = z.object({
    expected_name: z.string(),
    result: z.enum(['ok', 'needs_review', 'rejected']),
});

export const zCompensationChangeWritable = z.object({
    comment: z.string(),
    created_at: z.iso.datetime({ offset: true }).optional(),
    effective_at: z.iso.datetime({ offset: true }),
    id: z.int().optional(),
    kind: z.enum(['raise', 'original']),
    new: z.string(),
    old: z.string().optional(),
    status: z.enum(['pending', 'approved', 'rejected']).optional(),
});

export const zContactInfoRequestWritable = z.object({
    email: z.string(),
    emergency_contact: zEmergencyContact,
    telephone: z.array(z.string()),
});

export const zContactInfoResponseWritable = z.object({
    country: z.string(),
    email: z.string(),
    emergency_contact: zEmergencyContact,
    telephone: z.array(z.string()),
});

export const zContractWritable = z.object({
    approval_manager_id: z.int().optional(),
    custom_management_fee: z.string().optional(),
    customer: z.string(),
    customer_group_id: z.int().optional(),
    customer_id: z.int(),
    customer_sourced: z.boolean(),
    deposit_id: z.int().optional(),
    deposit_months: z.int().optional(),
    description: z.string(),
    fee_type: z.enum(['fixed', 'pay_as_you_go']),
    group: zContractGroup.optional(),
    health_insurance: zContractHealthInsurance,
    id: z.int(),
    job_opening_id: z.int().optional(),
    manager: zBasicUser.optional(),
    manager_id: z.int().optional(),
    raises: z.array(zRaise),
    rate: z.string().optional(),
    resigned: z.boolean(),
    role: z.string(),
    roles: z.array(z.string()),
    salary: z.string(),
    stack: z.array(z.string()),
    started_at: z.iso.datetime({ offset: true }),
    status: z.enum([
        'draft',
        'in_progress',
        'active',
        'terminated',
        'resigned',
        'solicited',
        'canceled',
    ]),
    terminated_at: z.iso.datetime({ offset: true }).optional(),
    termination_reason: z
        .enum([
            'acquisition',
            'performance',
            'shutdown',
            'management',
            'restructuring',
            'provisional',
            'recruited',
            'unmotivated',
            'cancelled',
            'personal',
            'solicited',
        ])
        .optional(),
    user_id: z.int(),
});

export const zContractingEntityWritable = z.object({
    address: zAddress,
    business_structure: z
        .enum([
            'ltd',
            'simplified_joint_stock_company',
            'llc',
            'corporation',
            'other',
            'joint_stock_company',
        ])
        .optional(),
    business_structure_other: z.string().optional(),
    contracts: z.array(zContractingEntityContractInfo),
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    locked: z.boolean(),
    name: z.string(),
    phone: z.string().optional(),
    status: z.enum(['available', 'retired', 'pending']),
    taxForm: zContractingEntityTaxForm.optional(),
    tax_id: z.string().optional(),
    title: z.string().optional(),
    type: z.enum(['individual', 'business']),
    updated_at: z.iso.datetime({ offset: true }),
});

export const zContractingEntitySelectionStatusResponseWritable = z.object({
    completed: z.boolean(),
    requested: z.boolean(),
});

export const zContractorCheckinWritable = z.object({
    calendly_url: z.string(),
    campaign: z.enum(['d30', 'd60', 'd90', 'd180', 'd270', 'quarterly']),
    completed_at: z.iso.datetime({ offset: true }).optional(),
    contractor_email: z.string(),
    contractor_full_name: z.string(),
    customer_company_name: z.string(),
    days: z.int(),
    id: z.int(),
    meeting_scheduled_at: z.iso.datetime({ offset: true }).optional(),
    status: z.enum(['pending', 'scheduled', 'completed', 'expired']),
    videoask_url: z.string(),
});

export const zContractorHealthResponseWritable = z.object({
    current_health: z
        .enum(['strong', 'monitor', 'at_risk', 'healthy', 'critical', 'exit'])
        .optional(),
    current_reason: z
        .enum(['customer_feedback', 'conflicting_feedback', 'feedback_outdated', 'other'])
        .optional(),
    history: z.array(zContractorHealthHistory),
    updated_at: z.iso.datetime({ offset: true }).optional(),
});

export const zCreateBankAccountRequestWritable = z.object({
    account_number: z.string().optional(),
    account_type: z.enum([
        'personal_checking',
        'personal_savings',
        'business_checking',
        'business_savings',
    ]),
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    contracting_entity_id: z.int(),
    country: z.string().length(2),
    iban: z.string().optional(),
    legal_name: z.string().min(1),
    memo: z.string().optional(),
    primary: z.boolean().optional(),
    routing_number: z.string().optional(),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zCreateBonusRequestWritable = z.object({
    amount: z.string(),
    comment: z.string().max(2000).optional(),
    effective_at: z.iso.datetime({ offset: true }),
});

export const zCreateCustomerGroupRequestWritable = z.object({
    approval_id: z.int().nullish(),
    approval_type: z.enum(['company', 'custom']),
    name: z.string().min(1),
    notes: z.string().optional(),
});

export const zCreateCustomerUserRequestWritable = z.object({
    email: z.string(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    roles: z
        .array(
            z.enum(['customer', 'customer_interviewer', 'customer_manager', 'customer_recruiter']),
        )
        .min(1),
    scheduling_url: z.string().nullish(),
});

export const zCreateEquipmentRequestWritable = z.object({
    brand: z.string().min(1),
    contract_id: z.int().optional(),
    cost: z.string(),
    customer_id: z.int(),
    description: z.string().optional(),
    invoice_id: z.int().optional(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    location: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .optional(),
    model: z.string().min(1),
    offer_letter_id: z.int().optional(),
    part_number: z.string().optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
});

export const zCreateRaiseRequestWritable = z.object({
    comment: z.string().max(2000).optional(),
    effective_at: z.iso.datetime({ offset: true }),
    new: z.string(),
});

export const zCustomerBasicProfileWritable = z.object({
    header: z.string().nullable(),
    logo: z.string().nullable(),
    name: z.string(),
    permalink: z.string(),
});

export const zCustomerBillingDataWritable = z.object({
    address: zAddress.optional(),
    contacts: z.array(zCustomerBillingContact),
    details: zCustomerBillingDetails,
});

export const zCustomerGroupWritable = z.object({
    approval_id: z.int().nullable(),
    approval_type: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    customer_id: z.int(),
    id: z.int(),
    name: z.string(),
    notes: z.string(),
    total_contractors: z.int(),
});

export const zCustomerInvoicesResponseWritable = z.object({
    current_page: z.int(),
    invoices: z.array(zCustomerInvoice),
    total: z.int(),
    total_pages: z.int(),
});

export const zCustomerPoliciesBenefitsWritable = z.object({
    background_check: z.boolean(),
    customer_status: z.enum([
        'prospect',
        'not_working_not_hiring',
        'not_working_hiring',
        'working_hiring',
        'working_not_hiring',
        'recruiting_only_hiring',
        'recruiting_only_not_hiring',
        'churned',
        'closed_lost',
    ]),
    equipment: z.enum(['not_provided', 'provided']).optional(),
    health_insurance: z.enum(['provided_by_customer', 'provided_by_remotely', 'not_offered']),
    is_grandfathered_customer: z.boolean(),
    laptop_specifications: zLaptopSpecifications.optional(),
    offer_expiration_days: z.int(),
    on_call: z.enum(['always_required', 'never_required', 'role_specific']).optional(),
    other_benefits: z.string(),
    policies_configured: z.boolean(),
    recruiting_only: z.boolean(),
    special_clauses: z.string(),
    stock_options_type: z.enum(['negotiable', 'yes', 'not_offered']),
    timezone: z.string(),
    timezone_overlap: z.enum(['full', 'partial', 'none']),
});

export const zCustomerProfileWritable = z.object({
    benefits: zBenefits,
    country: z.string().optional(),
    description: z.string(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineering_architecture: z.string(),
    engineers: z.int().nullable(),
    funding: z.int().nullable(),
    header: z.string().nullable(),
    hq: z.string(),
    hubspot_id: z.string().optional(),
    id: z.int(),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string(),
    logo: z.string().nullable(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string(),
    permalink: z.string(),
    product_demo: z.string(),
    public: z.boolean().optional(),
    sectors: z.array(z.int()),
    selling_pitch: z.string(),
    slack_channel_id: z.string().optional(),
    stage: z.enum(['agency', 'early', 'growth', 'mature', 'pe_backed', 'post_ipo']).optional(),
    status: z
        .enum([
            'prospect',
            'not_working_not_hiring',
            'not_working_hiring',
            'working_hiring',
            'working_not_hiring',
            'recruiting_only_hiring',
            'recruiting_only_not_hiring',
            'churned',
            'closed_lost',
        ])
        .optional(),
    tags: z.record(z.string(), z.string()),
    tech_stack: z.array(z.int()),
    timezone: z.string(),
    url: z.string(),
});

export const zCustomerUserWritable = z.object({
    created_at: z.iso.datetime({ offset: true }),
    email: z.string(),
    first_name: z.string(),
    hubspot_id: z.string().optional(),
    id: z.int(),
    inactive: z.boolean(),
    job_title: z.string(),
    last_activity_at: z.iso.datetime({ offset: true }).nullable(),
    last_name: z.string(),
    picture: z.string(),
    roles: z.array(z.string()),
    scheduling_url: z.string().optional(),
    type_of_role: z.string(),
});

export const zEquipmentWritable = z.object({
    accounting_status: z.enum(['pending', 'invoiced', 'paid']),
    brand: z.string(),
    confirmed_at: z.iso.datetime({ offset: true }).optional(),
    contract_id: z.int().optional(),
    cost: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    customer_id: z.int(),
    customer_invoice_id: z.int().optional(),
    deleted_at: z.iso.datetime({ offset: true }).optional(),
    delivered_at: z.iso.datetime({ offset: true }).optional(),
    description: z.string().optional(),
    expected_delivery: z.iso.datetime({ offset: true }).optional(),
    finished_delivery: z.iso.datetime({ offset: true }).optional(),
    id: z.int(),
    invoice: zDocument.optional(),
    invoice_id: z.int().optional(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    location: z.string().optional(),
    model: z.string(),
    offer_letter_id: z.int().optional(),
    order_number: z.string().optional(),
    ordered_at: z.iso.datetime({ offset: true }).optional(),
    part_number: z.string().optional(),
    picture: zDocument.optional(),
    picture_id: z.int().optional(),
    purchased_at: z.iso.datetime({ offset: true }).optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
    updated_at: z.iso.datetime({ offset: true }),
});

export const zEmploymentEquipmentWritable = z.object({
    items: z.array(zEquipmentWritable),
    provided: z.boolean(),
});

export const zContractorEmploymentInfoWritable = z.object({
    employment: zEmploymentDetails,
    equipment: zEmploymentEquipmentWritable,
    insurance: zEmploymentInsurance,
});

export const zExpandJobRequestWritable = z.object({
    expansions: z.array(z.enum(['seniority', 'current_salary'])).min(1),
});

export const zExpandJobResponseWritable = z.object({
    matches: z.int(),
});

export const zFinishProfileBuilderRequestWritable = z.object({
    permalink: z.string().min(1),
});

export const zFinishProfileBuilderResponseWritable = z.object({
    valid: z.boolean(),
});

export const zHealthInsurancePlanWritable = z.object({
    addons: z.array(zHealthInsurancePlanAddon),
    id: z.int(),
    name: z.string(),
    pricings: z.array(zHealthInsurancePlanPricing),
    type: z.enum(['STANDARD', 'PREMIUM', 'MATERNITY']),
    valid_from: z.iso.datetime({ offset: true }),
    valid_until: z.iso.datetime({ offset: true }),
});

export const zInitAiInterviewRequestWritable = z.object({
    conversation_id: z.string().min(1),
});

export const zJobDetailsWritable = z.object({
    company: zBasicCustomer,
    contract: zJobContract,
    equipment: z.array(zJobEquipment),
    group: z.string().optional(),
    insurance: zJobInsurance,
    manager: zBasicUser.optional(),
    pto: z.array(zJobPtoPolicy),
});

export const zJobExpansionsPreviewResponseWritable = z.object({
    combined: z.int(),
    expansions: z.array(zJobExpansionCount),
});

export const zLegalAddressWritable = z.object({
    city: z.string().min(1),
    country: z
        .string()
        .length(2)
        .regex(/^[A-Z]{2}$/),
    line_1: z.string().min(1),
    line_2: z.string().optional(),
    postal_code: z.string().min(1),
    region: z.string().min(1),
});

export const zCreateContractingEntityRequestWritable = z.object({
    address: zLegalAddressWritable,
    business_structure: z
        .enum([
            'ltd',
            'simplified_joint_stock_company',
            'llc',
            'corporation',
            'other',
            'joint_stock_company',
        ])
        .optional(),
    business_structure_other: z.string().optional(),
    name: z.string().min(1),
    phone: z.string().optional(),
    tax_id: z.string().optional(),
    title: z.string().optional(),
    type: z.enum(['individual', 'business']),
});

export const zLocationResponseWritable = z.object({
    address: zAddress,
    country_locked: z.boolean(),
});

export const zOpsApprovalWritable = z.object({
    created_at: z.iso.datetime({ offset: true }),
    entity_id: z.int(),
    id: z.int(),
    owner: zBasicUser.optional(),
    rejection_reason: z.string().optional(),
    reviewed_at: z.iso.datetime({ offset: true }).optional(),
    reviewed_by: zBasicUser.optional(),
    status: z.enum(['pending', 'approved', 'rejected']),
    summary: z.string(),
    type: z.enum(['bank_account_mismatch', 'country_change', 'id_verification_review']),
    user: zBasicUser,
    verification: zCandidateVerification.optional(),
});

export const zListOpsApprovalsResponseWritable = z.object({
    approvals: z.array(zOpsApprovalWritable),
    current_page: z.int(),
    total: z.int(),
    total_pages: z.int(),
});

export const zPayContractorInvoiceInputBodyWritable = z.object({
    api_key: z.string().min(1).regex(/\S/),
});

export const zPendingChangesResponseWritable = z.object({
    can_request_legal_name_change: z.boolean(),
    legal_name_change_in_review: z.boolean(),
    pending_country_change: zAddress.optional(),
});

export const zPersonalInfoWritable = z.object({
    birthday: z.string().optional(),
    civil_status: z.enum(['single', 'married', 'living_together', 'divorced', 'widow']).optional(),
    email: z.string(),
    first_name: z.string(),
    gender: z.enum(['male', 'female', 'other']).optional(),
    last_name: z.string(),
    legal_name: z.string(),
    legal_name_change_in_review: z.boolean(),
    national_id: z.string().optional(),
    nationality: z.string().optional(),
    residency: z.string().optional(),
    residency_locked: z.boolean(),
    telephone: z.array(z.string()),
    time_zone: z.string().optional(),
    us_visa: z.boolean(),
    valid_passport: z.boolean(),
});

export const zProfileBuilderPermalinkResponseWritable = z.object({
    permalink: z.string(),
});

export const zProfileBuilderWorkHistoryResponseWritable = z.object({
    agent_id: z.string(),
    work_experience: z.array(zWorkExperience),
});

export const zProfilePersonalInfoWritable = z.object({
    address: zAddress.optional(),
    birthday: z.iso.datetime({ offset: true }).optional(),
    civil_status: z.enum(['single', 'married', 'living_together', 'divorced', 'widow']).optional(),
    email: z.string(),
    first_name: z.string(),
    gender: z.enum(['male', 'female', 'other']).optional(),
    last_name: z.string(),
    legal_name: z.string(),
    nationality: z.string().optional(),
    residency: z.string().optional(),
    telephone: z.array(z.string()),
    time_zone: z.string().optional(),
    us_visa: z.boolean(),
    valid_passport: z.boolean(),
});

export const zProfileResponseWritable = z.object({
    applicant_roles: z.array(z.string()),
    certifications: z.array(zCertification),
    emergency_contact: zEmergencyContact,
    github_url: z.string().optional(),
    has_contracting_entities: z.boolean(),
    has_design_role: z.boolean(),
    job_title: z.string().optional(),
    linkedin_url: z.string().optional(),
    personal_info: zProfilePersonalInfoWritable,
    picture: z.string().optional(),
    portfolio_password: z.string().optional(),
    portfolio_url: z.string().optional(),
    public_id: z.string().optional(),
    resume_url: z.string().optional(),
    role: z.string().optional(),
    scheduling_url: z.string().optional(),
    target_salary: z.number(),
    technical_evidence_url: z.string().optional(),
    working_history: z.array(zProfileJob),
});

export const zProfileUpdateBookingUrlResponseWritable = z.object({
    calendly_url: z.string(),
});

export const zPublicCustomerProfileWritable = z.object({
    benefits: zBenefits,
    country: z.string().optional(),
    description: z.string(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineering_architecture: z.string(),
    engineers: z.int().nullable(),
    funding: z.int().nullable(),
    header: z.string().nullable(),
    hq: z.string(),
    hubspot_id: z.string().optional(),
    id: z.int(),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string(),
    logo: z.string().nullable(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string(),
    openings: z.array(zCompanyOpening),
    permalink: z.string(),
    product_demo: z.string(),
    public: z.boolean().optional(),
    sectors: z.array(z.int()),
    selling_pitch: z.string(),
    slack_channel_id: z.string().optional(),
    stage: z.enum(['agency', 'early', 'growth', 'mature', 'pe_backed', 'post_ipo']).optional(),
    status: z
        .enum([
            'prospect',
            'not_working_not_hiring',
            'not_working_hiring',
            'working_hiring',
            'working_not_hiring',
            'recruiting_only_hiring',
            'recruiting_only_not_hiring',
            'churned',
            'closed_lost',
        ])
        .optional(),
    tags: z.record(z.string(), z.string()),
    team: z.array(zCompanyTeamMember),
    tech_stack: z.array(z.int()),
    timezone: z.string(),
    url: z.string(),
});

export const zReassignResponsibilitiesRequestWritable = z.object({
    approval_manager: z.int().optional(),
    billing_contact: z.int().optional(),
    customer_approval_manager: z.int().optional(),
    customer_contact: z.int().optional(),
    hiring_manager: z.int().optional(),
    interviewer: z.int().optional(),
    manager: z.int().optional(),
    offer_letter_contact: z.int().optional(),
});

export const zRecordQuoteApprovalRequestWritable = z.object({
    client_approver_id: z.int().gte(1),
    comment: z.string().optional(),
});

export const zRejectOpsApprovalRequestWritable = z.object({
    reason: z.string().max(2000).optional(),
});

export const zRequestContractingEntitySelectionRequestWritable = z.object({
    application_id: z.int().nullish(),
});

export const zRequestProfileUpdateRequestWritable = z.object({
    event_uri: z.string().optional(),
    method: z.enum(['written_details', 'booked_call']),
    sections: z.array(zCandidateProfileUpdateSection).min(1),
});

export const zReviewApplicationFitRequestWritable = z.object({
    gaps: z.array(zItem).min(1),
    highlights: z.string().optional(),
});

export const zReviewCandidateVerificationRequestWritable = z.object({
    country_matches: z.boolean(),
    country_not_matched_valid_reason: z.boolean().optional(),
    id_matches: z.boolean(),
    reason: z.string().optional(),
});

export const zSalaryChangeRequestResponseWritable = z.object({
    notified: z.boolean(),
});

export const zScheduleContractorMeetingRequestWritable = z.object({
    event_uri: z.string().min(1),
});

export const zSchedulingUrlRequestWritable = z.object({
    scheduling_url: z.string(),
});

export const zSchedulingUrlResponseWritable = z.object({
    scheduling_url: z.string(),
});

export const zSearchContractorsRequestWritable = z.object({
    input: z.string(),
});

export const zSeniorityRequestWritable = z.object({
    reason: z.string().optional(),
    seniority: z.enum(['IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'IC6', 'M5', 'M6']),
});

export const zSeniorityResponseWritable = z.object({
    seniority: z
        .enum(['IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'IC6', 'M5', 'M6', 'lead', 'manager', 'director'])
        .optional(),
    updated_at: z.iso.datetime({ offset: true }).optional(),
    updated_by: zBasicUser.optional(),
});

export const zSetStatusRequestWritable = z.object({
    reset: z.boolean().optional(),
    status: z
        .enum([
            'prospect',
            'not_working_not_hiring',
            'not_working_hiring',
            'working_hiring',
            'working_not_hiring',
            'recruiting_only_hiring',
            'recruiting_only_not_hiring',
            'churned',
            'closed_lost',
        ])
        .optional(),
});

export const zSetUserStatusRequestWritable = z.object({
    active: z.boolean(),
});

export const zSetVisibilityRequestWritable = z.object({
    public: z.boolean(),
});

export const zShippingInfoRequestWritable = z.object({
    address: zLegalAddressWritable,
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    national_id: z.string().min(5),
    telephone: z.string(),
    update_personal_info: z.boolean().optional(),
});

export const zShippingInfoResponseWritable = z.object({
    address: zAddress,
    confirmed: z.boolean(),
    country_locked: z.boolean(),
    customer: zCustomerBasicProfileWritable.optional(),
    first_name: z.string(),
    last_name: z.string(),
    last_update: z.iso.datetime({ offset: true }).optional(),
    national_id: z.string().optional(),
    personal_address: zAddress,
    telephone: z.string().optional(),
});

export const zStartProfileBuilderRequestWritable = z.object({
    conversation_id: z.string().min(1),
});

export const zUpdateBankAccountRequestWritable = z.object({
    account_number: z.string().optional(),
    account_type: z.enum([
        'personal_checking',
        'personal_savings',
        'business_checking',
        'business_savings',
    ]),
    alias: z.string().optional(),
    bank_code: z.string().optional(),
    cbu: z.string().optional(),
    clabe: z.string().optional(),
    country: z.string().length(2),
    iban: z.string().optional(),
    legal_name: z.string().min(1),
    memo: z.string().optional(),
    primary: z.boolean().optional(),
    routing_number: z.string().optional(),
    swift: z.string().optional(),
    tax_id: z.string().optional(),
    transit_number: z.string().optional(),
});

export const zUpdateBillingAddressRequestWritable = z.object({
    legal_address: zLegalAddressWritable,
});

export const zUpdateBillingContactsRequestWritable = z.object({
    contacts: z.array(z.int()),
});

export const zUpdateBillingDetailsRequestWritable = z.object({
    auto_payment: z.boolean().optional(),
    deposit_months: z.int().gte(0).optional(),
    ein: z.string().optional(),
    legal_name: z.string().min(1),
    mercury_id: z.string().optional(),
    payment_reminder_disabled: z.boolean().optional(),
});

export const zUpdateCandidatePersonalInfoRequestWritable = z.object({
    birthdate: z.string().optional(),
    email: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    phones: z.array(z.string()).optional(),
    scheduling_url: z.string().optional(),
    timezone: z.string().optional(),
});

export const zUpdateCertificationsRequestWritable = z.object({
    certifications: z.array(zCertificationInput),
});

export const zUpdateContractRequestWritable = z.object({
    approval_manager_id: z.int().gte(1),
    customer_group_id: z.int().optional(),
    customer_sourced: z.boolean().optional(),
    deposit_months: z.int().gte(0).optional(),
    description: z.string().optional(),
    health_insurance_cost: z.string().optional(),
    health_insurance_provider: z.enum(['none', 'remotely', 'customer']),
    management_fee: z.string().optional(),
    manager_id: z.int().gte(1),
    role: z.string().min(1),
    started_at: z.iso.datetime({ offset: true }),
    terminated_at: z.iso.datetime({ offset: true }).optional(),
});

export const zUpdateContractingEntityRequestWritable = z.object({
    address: zLegalAddressWritable,
    business_structure: z
        .enum([
            'ltd',
            'simplified_joint_stock_company',
            'llc',
            'corporation',
            'other',
            'joint_stock_company',
        ])
        .optional(),
    business_structure_other: z.string().optional(),
    name: z.string().min(1).optional(),
    phone: z.string().optional(),
    tax_id: z.string().optional(),
    title: z.string().optional(),
    type: z.enum(['individual', 'business']).optional(),
});

export const zUpdateContractorHealthRequestWritable = z.object({
    comment: z.string().optional(),
    health: z.enum(['strong', 'monitor', 'at_risk', 'healthy', 'critical', 'exit']).optional(),
    reason: z.enum(['customer_feedback', 'conflicting_feedback', 'feedback_outdated', 'other']),
});

export const zUpdateContractorInvoiceAccountInputBodyWritable = z.object({
    account_id: z.int().optional(),
});

export const zUpdateContractorInvoiceStatusRequestWritable = z.object({
    status: z.enum([
        'draft',
        'error',
        'approved',
        'issued',
        'payment_scheduled',
        'paid',
        'pending',
    ]),
});

export const zUpdateCustomerDetailsRequestWritable = z.object({
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineers: z.int().gte(0).optional(),
    funding: z.int().gte(0).optional(),
    hq: z.string().min(1),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string().optional(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string().min(1),
    sectors: z.array(z.int()).optional(),
    tech_stack: z.array(z.int()).optional(),
    timezone: z.string(),
    url: z.string().optional(),
});

export const zUpdateCustomerInvoiceStatusRequestWritable = z.object({
    status: z.enum([
        'draft',
        'reviewed',
        'issued',
        'sent',
        'payment_scheduled',
        'review_payment',
        'paid',
        'written_off',
    ]),
});

export const zUpdateCustomerPoliciesBenefitsRequestWritable = z.object({
    background_check: z.boolean(),
    equipment: z.enum(['not_provided', 'provided']).optional(),
    health_insurance: z.enum(['provided_by_customer', 'provided_by_remotely', 'not_offered']),
    laptop_specifications: zLaptopSpecificationsRequest.optional(),
    offer_expiration_days: z.int().gte(0).lte(14).optional(),
    on_call: z.enum(['always_required', 'never_required', 'role_specific']).optional(),
    other_benefits: z.string().optional(),
    special_clauses: z.string().optional(),
    stock_options_type: z.enum(['negotiable', 'yes', 'not_offered']),
    timezone: z.string(),
    timezone_overlap: z.enum(['full', 'partial', 'none']),
});

export const zUpdateCustomerProfileRequestWritable = z.object({
    description: z.string(),
    email_domains: z.array(z.string()).optional(),
    employees: z
        .enum([
            '1-10',
            '11-50',
            '51-100',
            '101-250',
            '251-500',
            '501-1000',
            '1001-5000',
            '5001-10000',
            '10001+',
        ])
        .optional(),
    engineering_architecture: z.string().optional(),
    engineers: z.int().gte(0).optional(),
    funding: z.int().gte(0).optional(),
    hq: z.string().min(1),
    investors: z.array(z.int()).optional(),
    linkedin_url: z.string().optional(),
    market: z.enum(['crypto', 'consumer', 'enterprise', 'small_and_midsize']).optional(),
    name: z.string().min(1),
    product_demo: z.string().optional(),
    sectors: z.array(z.int()).optional(),
    selling_pitch: z.string().optional(),
    tech_stack: z.array(z.int()).optional(),
    timezone: z.string(),
    url: z.string().optional(),
});

export const zUpdateCustomerSectionRequestWritable = z.object({
    content: z.string().optional(),
    section: z.enum(['description', 'selling_pitch', 'engineering_architecture', 'product_demo']),
});

export const zUpdateCustomerTalentPreferencesInputBodyWritable = z.object({
    value: z.string().optional(),
});

export const zUpdateEmploymentInfoRequestWritable = z.object({
    approval_manager_id: z.int(),
    group_id: z.int().optional(),
    manager_id: z.int(),
});

export const zUpdateEquipmentRequestWritable = z.object({
    brand: z.string().min(1),
    contract_id: z.int().optional(),
    cost: z.string(),
    customer_id: z.int(),
    description: z.string().optional(),
    invoice_id: z.int().optional(),
    kind: z.enum(['laptop', 'monitor', 'keyboard', 'mouse', 'trackpad', 'other']),
    location: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .optional(),
    model: z.string().min(1),
    offer_letter_id: z.int().optional(),
    part_number: z.string().optional(),
    serial_number: z.string().optional(),
    status: z.enum([
        'pending',
        'ordered',
        'purchased',
        'shipped',
        'delivered',
        'confirmed',
        'not_delivered',
        'canceled',
        'sold_to_developer',
        'gifted_to_developer',
        'returned',
        'in_stock',
        'stolen_or_decommissioned',
    ]),
});

export const zUpdatePersonalInfoRequestWritable = z.object({
    birthday: z.string().optional(),
    civil_status: z.enum(['single', 'married', 'living_together', 'divorced', 'widow']).optional(),
    first_name: z.string(),
    gender: z.enum(['male', 'female', 'other']).optional(),
    last_name: z.string(),
    national_id: z.string().optional(),
    nationality: z.string().optional(),
    residency: z.string().optional(),
    time_zone: z.string().optional(),
    us_visa: z.boolean().optional(),
    valid_passport: z.boolean().optional(),
});

export const zUpdateTargetSalaryInputBodyWritable = z.object({
    target_salary: z.number().gte(0),
});

export const zUploadPictureResponseWritable = z.object({
    url: z.string(),
});

export const zUploadResponseWritable = z.object({
    url: z.string(),
});

export const zUserResponsibilitiesWritable = z.object({
    approval_manager: z.int().optional(),
    billing_contact: z.int().optional(),
    customer_approval_manager: z.int().optional(),
    customer_contact: z.int().optional(),
    hiring_manager: z.int().optional(),
    interviewer: z.int().optional(),
    manager: z.int().optional(),
    offer_letter_contact: z.int().optional(),
});

export const zWorkInfoRequestWritable = z.object({
    job_title: z.string().min(1),
    scheduling_url: z.string().optional(),
});

export const zWorkInfoResponseWritable = z.object({
    job_title: z.string(),
    scheduling_url: z.string(),
});

export const zWorkProfileRequestWritable = z.object({
    github_url: z.string(),
    linkedin_url: z.string(),
    portfolio_password: z.string(),
    portfolio_url: z.string(),
    resume_url: z.string(),
    scheduling_url: z.string(),
    target_salary: z.number().gte(0),
    technical_evidence_url: z.string(),
});

export const zWorkProfileResponseWritable = z.object({
    github_url: z.string(),
    has_design_role: z.boolean(),
    linkedin_url: z.string(),
    portfolio_password: z.string().optional(),
    portfolio_url: z.string().optional(),
    resume_url: z.string(),
    scheduling_url: z.string(),
    target_salary: z.number(),
    technical_evidence_url: z.string(),
});

export const zSearchApplicantsQuery = z.object({
    query: z.string(),
    limit: z.int().gte(1).lte(50),
});

/**
 * OK
 */
export const zSearchApplicantsResponse = z.array(zBasicCandidate);

export const zGetApplicationFitPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetApplicationFitResponse = zApplicationFitResponse;

export const zReviewApplicationFitBody = zReviewApplicationFitRequestWritable;

export const zReviewApplicationFitPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zReviewApplicationFitResponse = z.void();

export const zRescoreApplicationPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zRescoreApplicationResponse = z.void();

export const zListBackgroundChecksQuery = z.object({
    page: z
        .int()
        .gte(1)
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
    per_page: z.int().gte(1).lte(500).optional(),
    customer_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
    status: z
        .array(
            z.enum([
                'draft',
                'order_failed',
                'invitation_sent',
                'invitation_expired',
                'in_progress',
                'suspended',
                'paused',
                'dispute',
                'action_required',
                'completed',
                'rejected',
                'canceled',
            ]),
        )
        .optional(),
    invoice_year: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
    invoice_month: z.int().gte(1).lte(12).optional(),
});

/**
 * OK
 */
export const zListBackgroundChecksResponse = zBackgroundCheckOrdersResponse;

/**
 * OK
 */
export const zListBackgroundCheckPricingResponse = z.array(zBackgroundCheckCountryPricing);

export const zCheckrWebhookBody = z.union([z.instanceof(Blob), z.instanceof(File)]);

export const zCheckrWebhookHeaders = z.object({
    'X-Checkr-Signature': z.string().optional(),
});

/**
 * No Content
 */
export const zCheckrWebhookResponse = z.void();

/**
 * OK
 */
export const zGetAiInterviewConfigResponse = zAiInterviewConfig;

export const zInitAiInterviewBody = zInitAiInterviewRequestWritable;

/**
 * No Content
 */
export const zInitAiInterviewResponse = z.void();

export const zSearchCandidatesQuery = z.object({
    query: z.string(),
    limit: z.int().gte(1).lte(50),
});

/**
 * OK
 */
export const zSearchCandidatesResponse = z.array(zBasicCandidate);

export const zReviewCandidateVerificationBody = zReviewCandidateVerificationRequestWritable;

export const zReviewCandidateVerificationPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zUpdateCandidatePersonalInfoBody = zUpdateCandidatePersonalInfoRequestWritable;

export const zUpdateCandidatePersonalInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zRequestCandidateProfileUpdateBody = zRequestProfileUpdateRequestWritable;

export const zRequestCandidateProfileUpdatePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * Created
 */
export const zRequestCandidateProfileUpdateResponse = zCandidateProfileUpdateRequest;

export const zGetCandidateProfileUpdateBookingUrlPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateProfileUpdateBookingUrlResponse = zProfileUpdateBookingUrlResponse;

export const zFinishCandidateProfileBuilderBody = zFinishProfileBuilderRequestWritable;

export const zFinishCandidateProfileBuilderPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zFinishCandidateProfileBuilderResponse = zFinishProfileBuilderResponse;

export const zStartCandidateProfileBuilderBody = zStartProfileBuilderRequestWritable;

export const zStartCandidateProfileBuilderPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zStartCandidateProfileBuilderResponse = zProfileBuilderPermalinkResponse;

export const zGetCandidateProfileBuilderWorkHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateProfileBuilderWorkHistoryResponse = zProfileBuilderWorkHistoryResponse;

export const zGetContractorCheckinPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractorCheckinResponse = zContractorCheckin;

export const zScheduleContractorCheckinMeetingBody = zScheduleContractorMeetingRequestWritable;

export const zScheduleContractorCheckinMeetingPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zCompleteCustomerCheckinBody = z.object({
    comments: z.string().optional(),
    document: z.union([z.instanceof(Blob), z.instanceof(File)]).optional(),
    recording_url: z.string().optional(),
});

export const zCompleteCustomerCheckinPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetPublicCustomerProfilePath = z.object({
    permalink: z.string(),
});

/**
 * OK
 */
export const zGetPublicCustomerProfileResponse = zPublicCustomerProfile;

export const zDeleteContractorInvoicePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zPayContractorInvoiceBody = zPayContractorInvoiceInputBodyWritable;

export const zPayContractorInvoicePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zRegenerateContractorInvoicePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zUpdateContractorInvoiceStatusBody = zUpdateContractorInvoiceStatusRequestWritable;

export const zUpdateContractorInvoiceStatusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zUpdateContractorInvoiceAccountBody = zUpdateContractorInvoiceAccountInputBodyWritable;

export const zUpdateContractorInvoiceAccountPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zSearchContractorsQuery = z.object({
    query: z.string(),
    limit: z.int().gte(1).lte(50),
});

/**
 * OK
 */
export const zSearchContractorsResponse = z.array(zBasicUser);

export const zGetContractPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractResponse = zContract;

export const zUpdateContractBody = zUpdateContractRequestWritable;

export const zUpdateContractPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zUpdateContractResponse = z.void();

export const zListContractBonusesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListContractBonusesResponse = z.array(zBonus);

export const zCreateContractBonusBody = zCreateBonusRequestWritable;

export const zCreateContractBonusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * Created
 */
export const zCreateContractBonusResponse = zBonus;

export const zApproveContractBonusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    bonus_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zApproveContractBonusResponse = z.void();

export const zRejectContractBonusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    bonus_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zRejectContractBonusResponse = z.void();

export const zGetContractorHealthPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractorHealthResponse = zContractorHealthResponse;

export const zUpdateContractorHealthBody = zUpdateContractorHealthRequestWritable;

export const zUpdateContractorHealthPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zUpdateContractorHealthResponse = z.void();

export const zListContractRaisesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListContractRaisesResponse = z.array(zCompensationChange);

export const zCreateContractRaiseBody = zCreateRaiseRequestWritable;

export const zCreateContractRaisePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * Created
 */
export const zCreateContractRaiseResponse = zCompensationChange;

export const zApproveContractRaisePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    raise_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zApproveContractRaiseResponse = z.void();

export const zRejectContractRaisePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    raise_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zRejectContractRaiseResponse = z.void();

export const zUndoContractTerminationPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zUndoContractTerminationResponse = z.void();

export const zHandleCspReportBody = z.union([z.instanceof(Blob), z.instanceof(File)]);

export const zHandleCspReportHeaders = z.object({
    'Content-Type': z.string().optional(),
});

/**
 * No Content
 */
export const zHandleCspReportResponse = z.void();

export const zDeleteCustomerInvoicePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zRegenerateCustomerInvoicePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zUpdateCustomerInvoiceStatusBody = zUpdateCustomerInvoiceStatusRequestWritable;

export const zUpdateCustomerInvoiceStatusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zSearchCustomersQuery = z.object({
    query: z.string(),
    limit: z.int().gte(1).lte(50),
});

/**
 * OK
 */
export const zSearchCustomersResponse = z.array(zBasicCustomer);

export const zGetCustomerBillingDataPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerBillingDataResponse = zCustomerBillingData;

export const zUpdateCustomerBillingAddressBody = zUpdateBillingAddressRequestWritable;

export const zUpdateCustomerBillingAddressPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zUpdateCustomerBillingContactsBody = zUpdateBillingContactsRequestWritable;

export const zUpdateCustomerBillingContactsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zUpdateCustomerBillingDetailsBody = zUpdateBillingDetailsRequestWritable;

export const zUpdateCustomerBillingDetailsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zSearchCustomerContractorsBody = zSearchContractorsRequestWritable;

export const zSearchCustomerContractorsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zSearchCustomerContractorsResponse = z.array(zCustomerContractor);

export const zGetContractorEmploymentInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    contractor_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractorEmploymentInfoResponse = zContractorEmploymentInfo;

export const zUpdateContractorEmploymentInfoBody = zUpdateEmploymentInfoRequestWritable;

export const zUpdateContractorEmploymentInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    contractor_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetContractorPersonalInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    contractor_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractorPersonalInfoResponse = zProfilePersonalInfo;

export const zListCustomerGroupsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zListCustomerGroupsQuery = z.object({
    count: z.boolean().optional(),
});

/**
 * OK
 */
export const zListCustomerGroupsResponse = z.array(zCustomerGroup);

export const zCreateCustomerGroupBody = zCreateCustomerGroupRequestWritable;

export const zCreateCustomerGroupPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * Created
 */
export const zCreateCustomerGroupResponse = zCustomerGroup;

export const zListCustomerGroupApproversPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListCustomerGroupApproversResponse = z.array(zCustomerGroupApprover);

export const zDeleteCustomerGroupPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    group_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zDeleteCustomerGroupResponse = z.void();

export const zGetCustomerGroupPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    group_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerGroupResponse = zCustomerGroup;

export const zUpdateCustomerGroupBody = zCreateCustomerGroupRequestWritable;

export const zUpdateCustomerGroupPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    group_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateCustomerGroupResponse = zCustomerGroup;

export const zListCustomerInvoicesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zListCustomerInvoicesQuery = z.object({
    page: z
        .int()
        .gte(1)
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
    per_page: z.int().gte(1).lte(500).optional(),
});

/**
 * OK
 */
export const zListCustomerInvoicesResponse = zCustomerInvoicesResponse;

export const zGetCustomerPoliciesBenefitsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerPoliciesBenefitsResponse = zCustomerPoliciesBenefits;

export const zUpdateCustomerPoliciesBenefitsBody = zUpdateCustomerPoliciesBenefitsRequestWritable;

export const zUpdateCustomerPoliciesBenefitsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateCustomerPoliciesBenefitsResponse = zCustomerPoliciesBenefits;

export const zGetCustomerProfilePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerProfileResponse = zCustomerProfile;

export const zUpdateProfileBody = zUpdateCustomerProfileRequestWritable;

export const zUpdateProfilePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateProfileResponse = zCustomerProfile;

export const zGetCustomerBasicProfilePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerBasicProfileResponse = zCustomerBasicProfile;

export const zUpdateCustomerDetailsBody = zUpdateCustomerDetailsRequestWritable;

export const zUpdateCustomerDetailsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateCustomerDetailsResponse = zCustomerProfile;

export const zUploadCustomerHeaderBody = z.object({
    picture: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

export const zUploadCustomerHeaderPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUploadCustomerHeaderResponse = zUploadPictureResponse;

export const zUploadCustomerPictureBody = z.object({
    picture: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

export const zUploadCustomerPicturePath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUploadCustomerPictureResponse = zUploadPictureResponse;

export const zUpdateCustomerSectionBody = zUpdateCustomerSectionRequestWritable;

export const zUpdateCustomerSectionPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zUpdateCustomerSectionResponse = z.void();

export const zSetCustomerStatusBody = zSetStatusRequestWritable;

export const zSetCustomerStatusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zSetCustomerStatusResponse = z.void();

export const zUpdateCustomerTalentPreferencesBody =
    zUpdateCustomerTalentPreferencesInputBodyWritable;

export const zUpdateCustomerTalentPreferencesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zListCustomerUsersPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListCustomerUsersResponse = z.array(zCustomerUser);

export const zCreateCustomerUserBody = zCreateCustomerUserRequestWritable;

export const zCreateCustomerUserPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * Created
 */
export const zCreateCustomerUserResponse = zCustomerUser;

export const zUpdateCustomerUserBody = zCreateCustomerUserRequestWritable;

export const zUpdateCustomerUserPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    user_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zUpdateCustomerUserResponse = z.void();

export const zReassignCustomerUserResponsibilitiesBody = zReassignResponsibilitiesRequestWritable;

export const zReassignCustomerUserResponsibilitiesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    user_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zReassignCustomerUserResponsibilitiesResponse = z.void();

export const zGetCustomerUserResponsibilitiesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    user_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerUserResponsibilitiesResponse = zUserResponsibilities;

export const zSetCustomerUserStatusBody = zSetUserStatusRequestWritable;

export const zSetCustomerUserStatusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    user_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zSetCustomerUserStatusResponse = z.void();

export const zSetCustomerVisibilityBody = zSetVisibilityRequestWritable;

export const zSetCustomerVisibilityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zSetCustomerVisibilityResponse = z.void();

export const zGetCandidateCertificationHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateCertificationHistoryResponse = z.array(zCandidateCertificationEntry);

export const zGetCandidateExpectedSalaryHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateExpectedSalaryHistoryResponse = z.array(zCandidateExpectedSalaryEntry);

export const zGetCandidateExperimentsHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateExperimentsHistoryResponse = z.array(zCandidateExperimentsEntry);

export const zGetCandidateOpenToOpportunitiesHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateOpenToOpportunitiesHistoryResponse = z.array(
    zCandidateOpenToOpportunitiesEntry,
);

export const zGetCandidateProfileCompleteHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateProfileCompleteHistoryResponse = z.array(zCandidateProfileCompleteEntry);

export const zGetCandidateSeniorityHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateSeniorityHistoryResponse = z.array(zCandidateSeniorityEntry);

export const zGetCandidateSourceHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateSourceHistoryResponse = z.array(zCandidateSourceEntry);

export const zGetCandidateStatusHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateStatusHistoryResponse = z.array(zCandidateStatusEntry);

export const zGetCandidateWorkExperienceHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCandidateWorkExperienceHistoryResponse = z.array(zCandidateWorkExperienceEntry);

export const zGetContractorHealthHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractorHealthHistoryResponse = z.array(zContractorHealthEntry);

export const zGetCustomerStageHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetCustomerStageHistoryResponse = z.array(zCustomerStageEntry);

export const zGetJobOpeningCompanyOwnerHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetJobOpeningCompanyOwnerHistoryResponse = z.array(zJobOpeningCompanyOwnerEntry);

export const zGetJobOpeningHealthHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetJobOpeningHealthHistoryResponse = z.array(zJobOpeningHealthEntry);

export const zGetPaymentAttemptHistoryPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetPaymentAttemptHistoryResponse = z.array(zPaymentAttemptEntry);

export const zCreateEquipmentBody = zCreateEquipmentRequestWritable;

/**
 * OK
 */
export const zCreateEquipmentResponse = zEquipment;

export const zRecordEquipmentQuoteApprovalBody = zRecordQuoteApprovalRequestWritable;

export const zRecordEquipmentQuoteApprovalPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetEquipmentQuoteShippingInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetEquipmentQuoteShippingInfoResponse = zShippingInfoResponse;

export const zConfirmEquipmentQuoteShippingInfoBody = zShippingInfoRequestWritable;

export const zConfirmEquipmentQuoteShippingInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetEquipmentPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetEquipmentResponse = zEquipment;

export const zUpdateEquipmentBody = zUpdateEquipmentRequestWritable;

export const zUpdateEquipmentPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateEquipmentResponse = zEquipment;

export const zGetHealthInsurancePlanPath = z.object({
    type: z.enum(['STANDARD', 'PREMIUM', 'MATERNITY']),
});

/**
 * OK
 */
export const zGetHealthInsurancePlanResponse = zHealthInsurancePlan;

export const zImBulkPreflightBody = zBulkImSendRequestWritable;

/**
 * OK
 */
export const zImBulkPreflightResponse = zBulkImPreflightResponse;

export const zImBulkSendBody = zBulkImSendRequestWritable;

/**
 * OK
 */
export const zImBulkSendResponse = zBulkImSendResponse;

export const zExpandJobBody = zExpandJobRequestWritable;

export const zExpandJobPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zExpandJobResponse2 = zExpandJobResponse;

export const zGetJobExpansionPreviewPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetJobExpansionPreviewResponse = zJobExpansionsPreviewResponse;

export const zListOpsApprovalsQuery = z.object({
    page: z
        .int()
        .gte(1)
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
    per_page: z.int().gte(1).lte(500).optional(),
    status: z.enum(['pending', 'approved', 'rejected']).optional(),
    types: z
        .array(z.enum(['bank_account_mismatch', 'country_change', 'id_verification_review']))
        .optional(),
    user_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
    owner_id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
        .optional(),
});

/**
 * OK
 */
export const zListOpsApprovalsResponse2 = zListOpsApprovalsResponse;

export const zGetOpsApprovalPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetOpsApprovalResponse = zOpsApproval;

export const zApproveOpsApprovalPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zRejectOpsApprovalBody = zRejectOpsApprovalRequestWritable;

export const zRejectOpsApprovalPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zRescoreProspectPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zRescoreProspectResponse = z.void();

/**
 * OK
 */
export const zListBankAccountsResponse = z.array(zBankAccount);

export const zCreateBankAccountBody = zCreateBankAccountRequestWritable;

/**
 * Created
 */
export const zCreateBankAccountResponse = zBankAccountChange;

export const zCheckBankAccountNameBody = zCheckBankAccountNameRequestWritable;

/**
 * OK
 */
export const zCheckBankAccountNameResponse = zCheckBankAccountNameResult;

export const zDeleteBankAccountPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zDeleteBankAccountResponse = z.void();

export const zGetBankAccountPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetBankAccountResponse = zBankAccount;

export const zUpdateBankAccountBody = zUpdateBankAccountRequestWritable;

export const zUpdateBankAccountPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateBankAccountResponse = zBankAccountChange;

export const zSetDefaultBankAccountPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zSetDefaultBankAccountResponse = zBankAccountChange;

export const zChangeCountryBody = zLegalAddressWritable;

/**
 * OK
 */
export const zListContractingEntitiesResponse = z.array(zContractingEntity);

export const zCreateContractingEntityBody = zCreateContractingEntityRequestWritable;

/**
 * Created
 */
export const zCreateContractingEntityResponse = zContractingEntity;

export const zSelectNewContractingEntityBody = zCreateContractingEntityRequestWritable;

/**
 * No Content
 */
export const zSelectNewContractingEntityResponse = z.void();

export const zSelectExistingContractingEntityBody = zUpdateContractingEntityRequestWritable;

export const zSelectExistingContractingEntityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * No Content
 */
export const zSelectExistingContractingEntityResponse = z.void();

export const zGetContractingEntityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractingEntityResponse = zContractingEntity;

export const zUpdateContractingEntityBody = zUpdateContractingEntityRequestWritable;

export const zUpdateContractingEntityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zUpdateContractingEntityResponse = zContractingEntity;

export const zAssignContractingEntityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zAssignContractingEntityResponse = zContractingEntity;

export const zUploadUserDocumentBody = z.object({
    file: z.union([z.instanceof(Blob), z.instanceof(File)]),
    type: z.enum(['resume', 'technical_evidence', 'certification_evidence']),
});

/**
 * OK
 */
export const zUploadUserDocumentResponse = zUploadResponse;

/**
 * OK
 */
export const zGetUserJobDetailsResponse = zJobDetails;

/**
 * OK
 */
export const zGetLocationResponse = zLocationResponse;

export const zUpdateLocationBody = zLegalAddressWritable;

/**
 * OK
 */
export const zGetUserPendingChangesResponse = zPendingChangesResponse;

export const zUploadUserPictureBody = z.object({
    picture: z.union([z.instanceof(Blob), z.instanceof(File)]),
});

/**
 * OK
 */
export const zUploadUserPictureResponse = zUploadResponse;

/**
 * OK
 */
export const zGetUserProfileResponse = zProfileResponse;

/**
 * OK
 */
export const zRequestSalaryChangeResponse = zSalaryChangeRequestResponse;

/**
 * OK
 */
export const zGetUserShippingInfoResponse = zShippingInfoResponse;

export const zConfirmUserShippingInfoBody = zShippingInfoRequestWritable;

export const zUpdateUserTargetSalaryBody = zUpdateTargetSalaryInputBodyWritable;

/**
 * OK
 */
export const zGetUserWorkProfileResponse = zWorkProfileResponse;

export const zUpdateUserWorkProfileBody = zWorkProfileRequestWritable;

export const zListUserBankAccountsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListUserBankAccountsResponse = z.array(zBankAccount);

export const zGetUserCertificationsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetUserCertificationsResponse = z.array(zCertification);

export const zUpdateUserCertificationsBody = zUpdateCertificationsRequestWritable;

export const zUpdateUserCertificationsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetUserContactInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetUserContactInfoResponse = zContactInfoResponse;

export const zUpdateUserContactInfoBody = zContactInfoRequestWritable;

export const zUpdateUserContactInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zListUserContractingEntitiesPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListUserContractingEntitiesResponse = z.array(zContractingEntity);

export const zGetContractingEntitySelectionPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractingEntitySelectionResponse = zContractingEntity.nullable();

export const zRequestContractingEntitySelectionBody =
    zRequestContractingEntitySelectionRequestWritable;

export const zRequestContractingEntitySelectionPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetContractingEntitySelectionStatusPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetContractingEntitySelectionStatusResponse =
    zContractingEntitySelectionStatusResponse;

export const zListUserContractsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zListUserContractsResponse = z.array(zContract);

export const zListUserDocumentsPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zListUserDocumentsQuery = z.object({
    background_checks: z.boolean().optional(),
    equipment: z.boolean().optional(),
    expenses: z.boolean().optional(),
});

/**
 * OK
 */
export const zListUserDocumentsResponse = z.array(zContractorDocument);

export const zGetUserPersonalInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetUserPersonalInfoResponse = zPersonalInfo;

export const zUpdateUserPersonalInfoBody = zUpdatePersonalInfoRequestWritable;

export const zUpdateUserPersonalInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetUserSchedulingUrlPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetUserSchedulingUrlResponse = zSchedulingUrlResponse;

export const zUpdateUserSchedulingUrlBody = zSchedulingUrlRequestWritable;

export const zUpdateUserSchedulingUrlPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetUserSeniorityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetUserSeniorityResponse = zSeniorityResponse;

export const zUpdateUserSeniorityBody = zSeniorityRequestWritable;

export const zUpdateUserSeniorityPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

export const zGetUserWorkInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * OK
 */
export const zGetUserWorkInfoResponse = zWorkInfoResponse;

export const zUpdateUserWorkInfoBody = zWorkInfoRequestWritable;

export const zUpdateUserWorkInfoPath = z.object({
    id: z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});
